export default {
  ActionConfirm: "Fəaliyyəti təsdiqləyin",
  ActivatePromocode: "Promokodu aktivləşdirmək",
  AddFile: "Faylı əlavə etmək",
  AddToFavorites: "Seçilmişlərə əlavə etmək",
  "Andar Bahar": "Andar Bahar\n",
  ApplyFilter: "Filtr tətbiq etmək",
  AppsPage: {
    blocks: {
      descriptionOne: "Aktual güzgülər axtarmaq lazım deyil",
      descriptionThree: "Bütün aksiyalar, turnirlər və tirajlar barədə fərdi bildirişlər",
      descriptionTwo: "Tətbiqin istifadəçiləri üçün unikal aksiya və təkliflər",
      titleOne: "OLİMP hər zaman əlinizin altındadır",
      titleThree: "Bütün hadisələr və təkliflərdən xəbərdar olun",
      titleTwo: "Eksklüziv aksiyalar və turnirlər"
    },
    dontWorry: "Narahat olmayın, bu təhlükəsizdir",
    howToInstall: "Necə quraşdırmaq",
    installAndroid: "Android üçün yükləmək",
    installIos: "IOS üçün yükləmək",
    installIsSafe: "Quraşdırma təhlükəsizdir",
    qrText: "Tətbiqi yükləmək üçün kameranı QR koda yönəldin",
    safeDescription: "Google-un həyəcan oyunlarına münasibətdə siyasətinə görə tətbiqi Play Marketdə təqdim edə bilmirik. Quraşdırmaq üçün təlimatlara əməl edin.",
    seo: {
      all: {
        block_one: {
          description: "{platform} — geniş çeşidli əyləncələrə malik virtual mərc və həyəcan oyunları üçün müasir platformadır. Biz istifadəçilərin rahatlığına xüsusi diqqət yetiririk, məhz buna görə də bizim onlayn platformamıza istənilən qurğudan - həm kompüterdən, həm də smartfondan daxil olmaq olar. Olymp Casino mobil tətbiqi populyar əməliyyat sistemlərində - Android və iOS bazasında işləyən bütün müasir telefonlar üçün uyğunlaşdırılıb. Həyəcan oyunlarının həvəskarları onlar üçün əlverişli vaxtda istənilən yerdə internet platformasının bütün potensialından istifadə edə bilərlər.",
          title: "{platform} mobil tətbiqi"
        },
        block_three: {
          description: "Tətbiqi yükləmiş və orada qeydiyyatdan keçmiş istənilən oyunçu saytın bütün funksionallığından və tam alətlər dəstindən istifadə edə bilər. Mobil tətbiqdə tam olaraq nə mövcuddur? Şəxsi kabinetiniz vasitəsilə siz:",
          list: {
            five: "Oyun hesabında maliyyə əməliyyatlarının tarixçəsi - vəsait çıxarmaq üçün sifarişlər, ödənişlər və mərclər barədə məlumatı öyrənə bilərsiniz.",
            four: "Bonuslardan - xoşgəldin paketindən və digər hədiyyələrdən istifadə edə bilərsiniz.",
            one: "Profili tənzimləyə - telefon nömrəsi və ya elektron poçt ünvanınə əlavə edə, özünüz haqqında məlumatları doldura və dəyişdirə bilərsiniz.",
            three: "Mesajlar vasitəsilə kazinodan göndərişləri izləyə bilərsiniz.",
            two: "Balansınızı yoxlaya, istənilən rahat üsullardan istifadə edərək hesabınızı artıra, uduş məbləğlərini çıxara və dərhal keşbek əldə edə bilərsiniz."
          },
          text: "Siz Olymp Casino-da onlayn oynaya və qeydiyyat prosedurundan dərhal sonra mərc edə bilərsiniz. Sadəcə olaraq minimum depozit qoymalı və bəyəndiyiniz əyləncəni seçməlisiniz - tətbiqimizdə oyun avtomatları, lotereyalar, sürətli, idman və klassik oyunlar, live-kazinolar, idman mərcləri və müxtəlif turnirlər təqdim edilir. Olymp Casino tətbiqində onlayn sessiya zamanı hər hansı sualınız yaranarsa, texniki dəstək köməyinizə gələcək. Sadəcə çatı açmaq və xüsusi formada mesaj qoymaq kifayətdir.",
          title: "Funksional"
        },
        block_two: {
          description: "Olymp Casino mobil tətbiqi ingilis, qazax, özbək, qırğız və rus dillərində işləyir - onu istədiyiniz vaxt dəyişə bilərsiniz. Tətbiq maksimum rahatlıqla telefon vasitəsilə istifadə üçün uyğunlaşdırılıb - bütün interfeys elementləri mobil ekranların ölçüsü nəzərə alınmaqla bura köçürülüb. Hər bir qeydiyyatdan keçmiş smartfon sahibi saytın masaüstü versiyasının bütün funksiyalarına çıxış əldə edə bilər:",
          list: {
            one: "Kompüterdən istifadə edə bilərsiniz. Bunun üçün istənilən brauzer vasitəsilə rəsmi  {platform} portalını işə salın və ya axtarış sistemi vasitəsilə işçi güzgünü açın. Orada \"iOS üçün quraşdırmaq\" və \"Android üçün yükləmək\" düymələri olan səhifə tapa bilərsiniz. Sizin üçün münasib olan variantın üzərinə klikləyin və telefonun kamerasından istifadə edərək QR kodunu skan edin. Onun ekranında keçid görünəcək - həmin keçid üzrə hərəkət edin. Əgər siz iPhone istifadə edirsinizsə, onu endirə biləcəyiniz App Store-da tətbiqimizə yönləndiriləcəksiniz. Əgər sizdə Android əməliyyat sistemidirsə, tətbiqi quraşdırmaq üçün icazə verilməli və onun bitməsini gözləməlisiniz.",
            two: "Mobil qurğulardan istifadə edə bilərsiniz. {platformSite} saytına daxil olun - Olymp veb-saytının mobil versiyası açılacaq. Tətbiqi ödənişsiz yükləmək üçün əvvəlcə smartfonunuzun əməliyyat sisteindən asılı olaraq iki yükləmə düyməsindən sizə lazım olanı seçin. Əvvəlcə telefonunuzun parametrlərinə baxmağı və naməlum faylların quraşdırılmasına icazə verməyi unutmayın - bu təhlükəsizdir. Tətbiq bir neçə dəqiqə ərzində yüklənəcək."
          },
          text: "\"Giriş\" düyməsini sıxın və avtorizasiyaya başlayın. {platform} akkauntunuz hələ yoxdursa, onu yaratmağın əsl vaxtıdır. Müvafiq sətirlərə telefon nömrəsini və ya elektron ünvanı daxil edin, güclü şifrə fikirləşin və hərəkəti təsdiq edin.",
          title: "Proqramı harada yükləmək olar"
        }
      },
      android: {
        block_four: {
          description: "{platform} mobil tətbiqi ingilis, qazax, özbək, qırğız və rus dillərində işləyir - onu istədiyiniz vaxt dəyişə bilərsiniz. Tətbiq maksimum rahatlıqla telefon vasitəsilə istifadə üçün uyğunlaşdırılıb - bütün interfeys elementləri mobil ekranların ölçüsü nəzərə alınmaqla bura köçürülüb. Hər bir qeydiyyatdan keçmiş smartfon sahibi saytın masaüstü versiyasının bütün funksiyalarına çıxış əldə edə bilər:",
          list: {
            five: "Şəxsi mesajlar.",
            four: "Ödənişlərin, mərclərin və vəsait çıxarışı üçün sifarişlərin tarixçəsi.",
            one: "Profil parametrləri.",
            three: "Promokodlar və hədiyyələr - frispinlər, pulsuz mərclər və hesabın artırılmasına görə bonuslar.",
            two: "Oyun hesabı ilə əməliyyatlar - hesabın artırılması, vəsait çıxarışı və dərhal keşbek."
          },
          text: "Ən əsası isə telefonunuz və ya planşetiniz vasitəsilə sizi maraqlandıran istənilən oyunu sınaya, idman mərclərində şansınızı yoxlaya, aksiyalarda və turnirlərdə iştirak edə bilərsiniz. Casino Olymp hər zaman əlinizin altında olacaq, fərdi bildirişlər sayəsində isə siz eksklüziv təklifləri qaçırmayacaqsınız.",
          title: "Funksional"
        },
        block_one: {
          description: "{platform}-da harada yerləşməsindən asılı olmayaraq zövqlə dincəlməyə üstünlük verən hər kəs üçün  həyəcan oyunları üzrə zəngin əyləncə kolleksiyası toplanmışdır. İdman mərcləri və lotereyalar, sürətli və mərc oyunları, live-kazinolar və slotlar - oyun proqramı birbaşa telefonunuzdan sizin üçün əlçatandır! Android əməliyyat sisteminə əsaslanan smartfonların sahibləri hər şey edə bilərlər - biz xüsusi olaraq sizin üçün Android əməliyyat sistemində xüsusi Olymp mobil tətbiqini hazırlamışıq. Telefon və ya planşet vasitəsilə şəxsi hesabınızı artırın, sevimli oyun avtomatlarınızı və slotları onlayn işə salın və prosesdən həzz alın.",
          title: "Android üçün Olymp Casino tətbiqi"
        },
        block_three: {
          description: "Android üçün Olymp tətbiqini rəsmi internet saytından ödəniş yükləmək niyyətindəsiniz? Mobil qurğunuzu APK fayllarını quraşdırmaq üçün hazırlamalısınız. Əvvəlcə lazımi icazələri aktivləşdirin:",
          list: {
            four: "“Bu mənbədən quraşdırmaya icazə ver” tələb edildikdə, yükləməyə başlamaq üçün düyməni basın.",
            one: "Smartfonunuzda Parametrlərə keçin və \"Tətbiqlər\" bəndini tapın.",
            three: "Naməlum tətbiqlərin quraşdırılmasına icazəni təmin edin.",
            two: "İcazələr menyusunu açın."
          },
          text: "Android üçün Olymp proqramını QR kodundan istifadə etməklə portalın masaüstü versiyası vasitəsilə yükləyə bilərsiniz. O, birbaşa səhifədə görünəcək – sadəcə olaraq smartfonun kamerasını koda yönəltmək və yükləmə linkini gözləmək lazımdır. Olymp Casino-nun mobil versiyası ilə quraşdırma prosesi bir neçə sadə addımla həyata keçirilir. Proqramı smartfon vasitəsilə yükləmək üçün brauzerinizdə portalın mobil versiyasını açın. Orada \"Tətbiqi yüklə\" düyməsini görəcəksiniz. Bunun üzərinə klikləyin və qarşınızda “Yüklə” yazısı görünəcək. Quraşdırmaq üçün keçidləri rahat basa bilərsiniz - bu, təhlükəsizdir, fayl etibarlı mənbədən endiriləcəkdir. Hazırdır! Mobil tətbiqin bütün üstünlüklərindən istifadə edə bilərsiniz. İndi siz işçi güzgülər axtarmaq və ya VPN quraşdırmaq ehtiyacından azadsınız - Olymp Casino mobil tətbiqi İnternetə çıxışınız olduğu müddətdə işləyəcək. Bu tətbiqin ən son versiyayadək yenilənməsi tələb olunursa, onun düzgün işləməsini təmin etmək üçün bunu edin.",
          title: "Quraşdırma təlimatları"
        },
        block_two: {
          description: "Android üçün {platform} mobil tətbiqi ən yaxşı həyəcan və idman mərc oyunları dünyasına bələdçinizdir. Haradan yükləyə bilərsiniz? Android üçün mobil marketlərdə - məsələn, Google Play Market, AppGallery və ya hər hansı digər oxşar tətbiq mağazasında - həyəcan oyunları ilə bağlı xüsusi siyasətlər mövcuddur. Orada yalnız üçüncü tərəf tərtibatçılarının layihələrini tapa bilərsiniz. Onların rəsmi Olymp Casino veb-saytı ilə heç bir əlaqəsi yoxdur. Orijinal tətbiqimizi tapmaq üçün kompüterinizdə və ya mobil cihazınızda olymp.casino əsas veb-saytını açmalısınız.",
          title: "Proqramı harada yükləmək olar"
        }
      },
      ios: {
        block_one: {
          description: "iPhone və iPad sahibləri arasında {platform} həyəcan oyunlarının çoxlu pərəstişkarları var. iOS əməliyyat sisteminə əsaslanan cihazlar üçün mobil tətbiqiniz istifadəçilər üçün geniş imkanlar açır və tam fəaliyyət azadlığı təmin edir. İstənilən vaxt cibinizdə tam onlayn kazino funksionallığı ilə böyük bir əyləncə kataloqu mövcuddur. Hesabınıza vəsait qoyun, profil məlumatlarınızı idarə edin, istənilən məbləğdə mükafatları nağdlaşdırın, onlayn rejimdə oynayın və hər gün yeni oyunlar sınayın. iOS üçün Olymp casino mobil tətbiqi sizə istədiyiniz qədər əylənməyə və fayda əldə etməyə kömək edəcək! Bunu etmək üçün telefonunuzu və ya planşetinizi düzgün şəkildə \"təchiz etməlisiniz\" və əyləncəyə keçməlisiniz. ",
          title: "iPhone üçün Olymp Casino iOS tətbiqi"
        },
        block_three: {
          description: "iOS əməliyyat sistemi ilə cihazlarınız üçün Olymp casino tətbiqi sizə platformada həyəcan oyunları əyləncələrinin bütün kolleksiyasına - çoxsaylı slotlar, masa, idman və crash oyunları, masalar, lotereyalar, aksiyalar, turnirlərə tam giriş imkanı verir. Mobil tətbiqdəki şəxsi hesabınız vasitəsilə istənilən zəruri hərəkətləri edə bilərsiniz:",
          list: {
            five: "Əməliyyatlar tarixçənizə baxın - bütün vəsait çıxarma sifarişləri, əməliyyatlar və mərclər.",
            four: "Kazinodan gələn mesajları oxuyun.",
            one: "Profilinizdə şəxsi məlumatlarınızı dəyişdirin və yoxlamadan keçin.",
            three: "Hədiyyələr alın, aktivləşdirin və geri qazanın, o cümlədən yeni gələnlər üçün xoşgəldin bonusu.",
            two: "Hesabınızı artırın, uduşlarınızı nağdlaşdırın və dərhal keşbek əldə edin."
          },
          text: "Xüsusilə mobil tətbiq istifadəçiləri üçün bir çox unikal təkliflər nəzərdə tutulmuşdur: bütün hadisələrdən xəbərdar olmaq və sərfəli aksiyalar, cari lotereyalar və eksklüziv turnirlər haqqında operativ məlumat əldə etmək üçün bildirişləri açmağı unutmayın. Depozitinizi artırmaq, mərc etmək, oyun avtomatlarını “sınamaq” və şansınızı artırmaq vaxtıdır. Biz Olymp casino tətbiqində hər virtual sessiyanın sizə yalnız xoş təcrübələr bəxş etməsinin qayğısına qalmışıq.",
          title: "Funksionallıq və imkanlar"
        },
        block_two: {
          description: "Biz istifadəçiləri oyun üçün lazım olan alətlərlə effektiv və rahat şəkildə necə təmin edəcəyimizi bilirik. {platform} mobil tətbiqi Apple brend mağazasında mövcuddur - ödənişsizdir. iOS üçün rəsmi Olymp tətbiqini yükləmək üçün App Store mağazasından yükləmə linki əldə etməlisiniz. Bunu etmək üçün iki yol var - sizin üçün daha rahat olanı seçə bilərsiniz:",
          list: {
            one: "Kompüterinizdə rəsmi Olymp casino saytını işə salın və mobil tətbiqə keçid olan səhifəyə keçin. Orada siz QR-kodu görəcəksiniz - cihazınızın kamerasını ona yönəldin və yükləmə linkinə klikləyin.",
            two: "iOS əməliyyat sistemi ilə işləyən cihazınız vasitəsilə birbaşa {platformSite} portalına keçin - mobil versiya açılacaq. Olymp tətbiqini iPhone və ya iPad-a bu şəkildə yükləmək üçün “iOS üçün quraşdır” düyməsini basmağınız kifayətdir. Siz App Store-a yönləndiriləcəksiniz və tətbiqi quraşdırmağa başlaya bilərsiniz."
          },
          text: "Yükləmə tamamlandıqda, sistemdə hesab yarada və ya artıq şəxsi kabinetiniz varsa daxil ola və ən maraqlı işə - {platform} əyləncəsinə keçə bilərsiniz!",
          title: "Tətbiqi quraşdırmaq asandır"
        }
      }
    },
    seoText: "-",
    seoTitle: "SEO mətn",
    slider: {
      textEight: "Saytda \"Tətbiqi yükləmək\" düyməsini basın",
      textFive: "\"Quraşdır\" düyməsini basın",
      textFour: "Yüklənmiş tətbiq faylına klikləyin",
      textOne: "Yükləməyə başlamaq üçün \"Yükləmək\" düyməsini klikləyin",
      textSeven: "Telefonunuzun kamerasını QR koduna yönəldin və veb saytına daxil olun",
      textSix: "Proqramı masaüstünüzdən işə salın və oynayın",
      textThree: "Naməlum mənbələrdən tətbiqlərin quraşdırılmasına icazə verin",
      textTwo: "\"Naməlum tətbiqləri quraşdırmaq\" bölməsinə keçin"
    },
    slides: {
      allowInstall: "Naməlum mənbələrdən quraşdırmaya icazə verin",
      cancel: "Ləğv etmək",
      download: "Yükləmək",
      downloadApp: "Tətbiqi yükləmək",
      downloadIsDone: "Yükləmə bitdi",
      installUnknownApp: "Naməlum tətbiqlərin quraşdırılması",
      isntall: "Quraşdırmaq",
      moveToSite: "Sayta keçmək",
      myFiles: "Mənim fayllarım",
      safeDescription: "Play ьMarketdən olmayan tətbiqlərin quraşdırılması. Faylı yalnız etibarlı mənbədən yükləyin.",
      settings: "Parametrlər"
    },
    textForMobile: {
      androidAndIos: "Android və iOS-da",
      downloadOnAndroid: "Android üçün yükləyin",
      downloadOnAndroidAndIos: "Android və iOS üçün yükləyin",
      downloadOnIos: "iOS üçün yükləyin",
      onAndroid: "Android-də",
      onIos: "iOS-da"
    },
    title: "Olymp tətbiqi"
  },
  Aviator: "Aviator",
  Basket: "Səbət",
  BeforeEndPromotion: "Aksiyanın bitməsinə qədər",
  BeforeStartPromotion: "Aksiyanın başlamasına qədər",
  Betgames: "Betgames",
  Bets: "Mərclər",
  BonusBalanceOff: "Siz əsas kazino balansına keçdiniz. Hesabınızı artırın və sevimli oyunlarınızı oynayın.",
  BonusBalanceOn: "Siz bonus balansınıza keçdiniz.",
  BonusesAndPromotions: "Bonus və aksiyalar",
  BonusesAndPromotionsSection: "Bonus və aksiyalar bölməsi",
  Categories: "Kateqoriyalar",
  Chat: "Çat",
  CloseMatchTracker: "Matç izləyicisini bağlayın",
  CoefficientChanged: "Əmsal dəyişdi",
  ContactSupport: "Dəstək xidmətinə müraciət edin",
  "Cricket X": "Kriket X",
  DeleteConfirm: "Silinmə təsdiqi",
  DeleteConfirmText: "Əvvəllər yüklənmiş faylları silmək istədiyinizə əminsiniz?",
  DeleteFiles: "Faylları silmək",
  DenyReason: "Rədd edildi",
  DocumentAlreadyAttached: "Bu fayl artıq əlavə olunub",
  DocumentDoesntMeetRequirements: "Sənəd tələblərə cavab vermir",
  DocumentResolutionTooBig: "Fotoşəklin həlli çox yüksəkdir. Maksimum icazə verilən - {value} meqapiksel",
  DocumentsFilesLimits: "(faylların maksimum sayı - {fields}, maksimum fayl ölçüsü - {size} Mb)",
  DocumentsUploadError: "Faylları yükləyərkən xəta baş verdi - {files}. Qalan fayllar yoxlama üçün göndərilib. Bu faylları yenidən endirməyə cəhd edə bilərsiniz.",
  DownloadOn: "Burada yükləyin",
  EuroLanding: {
    activate: "<br />“Bonuslar” bölməsində <span>aktivləşdirin</span>",
    bonusText: "<span>qeydiyyata görə</span><span>fribet!</span><b>{freebet}</b>",
    register: "Olymp Casino saytında <span>qeydiyyatdan keçin</span><br />"
  },
  Event: "Hadisə",
  Exclusive: "Exclusive",
  Expires: "Bitir",
  ForbidenBonus: "Cari gün üçün mükafatlar artıq təqdim edilib",
  Found: "Tapılıb",
  FruityWheel: {
    btn: "Fırladın",
    title: "Fırladın və xoşgəldin bonusunuzu öyrənin"
  },
  GatesOfOlympus: {
    completeSignIn: "Qeydiyyatı indi tamamlayın və bonus qazanın",
    getBonus: "Bonusu götürmək",
    spin: "Fırladın",
    titleFirstLine: "Çarxı fırladın",
    titleSecondLine: "bonus alın",
    twist: "Fırlatmaq",
    youWin: "Siz uddunuz",
    yourBonus: "Sizin bonusunuz"
  },
  GetYourPrizes: "Mükafatları götürün",
  GoldenTimesKz: {
    bonusText: "Təbrik edirik! Sizin uduşunuz",
    headTitle: "<br /> bonusunu götürün və cekpotu qazanın!",
    labelText: "Telefon nömrənizi daxil edin"
  },
  InformationAllPromotions: "Bütün aksiyalar haqqında məlumat",
  InitialCoefficient: "İlkin əmsal:",
  JetX: "JetX",
  LongTermRates: "Uzunmüddətli mərclər",
  MainSite: "Əsas sayt",
  MatchTracker: "Matç izləyicisi",
  MaximizeMatchTracker: "Matç izləyicisini böyütmək",
  MinimizeMatchTracker: "Matç izləyicisini kiçiltmək",
  Mobile: "Mobil",
  MobileAppSetupLanding: {
    app: "/app",
    appText: "Menyu elementini seçin /app",
    getLink: "və ya Telegram botunda link əldə edin",
    getLinkButton: "Link əldə etmək",
    groups: {
      four: "Bütün <br/> tədbirlər və təkliflərdən xəbərdar olun",
      one: "Tətbiqin quraşdırılmasına görə <span> depozitsiz 100 FS </span>",
      three: "Eksklüziv <br/> aksiyalar və turnirlər",
      two: "<br/> aktual güzgüləri axtarmağa ehtiyac yoxdur"
    },
    start: "/başla",
    startText: "/start düyməsini klikləməklə Telegram botunu işə salın",
    successLink: "Link uğurla göndərildi",
    text: "Olymp mobil tətbiqini yükləyin və istənilən vaxt oynamağa hazır olun",
    title: "<span>100 FS olmadan<br/> depozit</span> OLYMP quraşdırmaq üçün"
  },
  MobileApplications: "Mobil tətbiqlər",
  MyDocuments: "Mənim sənədlərim",
  NewYearRules: {
    "1": "Aksiya müddəti: 20.12.2024 00:00 - 02.01.2025 23:59:59 GMT +5",
    "10": "Aviator fribetləri",
    "11": "JetX fribetləri",
    "12": "Promo səhifəsində bonus qazandığınız halda, “Bonusa keç” düyməsini basmaqla bonus şəxsi hesabınıza, “Bonuslar” bölməsinə əlavə olunur",
    "13": "Əlavə edilmiş bonusların aktivləşdirilməsi 3 gün ərzində mümkündür",
    "14": "Aktivləşdirildikdən sonra 1 gün ərzində depozit qoyulmalıdır",
    "15": "Bonus vəsaitlərinin mərc edilməsi 1 gün ərzində tamamlanmalıdır",
    "16": "Hər bir bonus üçün ətraflı şərtlər şəxsi hesabınızdakı “Bonuslar” səhifəsində mövcuddur",
    "2": "Promo səhifəsində hər gün bonus almaq üçün 3 cəhd verilir",
    "3": "Cəhdlərin sayı GMT +5 üzrə saat 00:00-da aksiyanın keçirildiyi dövrdə hər gün 3-ə sıfırlanır",
    "4": "Bonus qazanmaq üçün istifadəçi hər gün promo səhifəsinə daxil olmalı və SPIN düyməsini basaraq slot maşını işə salmalıdır",
    "5": "SPIN düyməsini hər basmaq bir cəhd edir",
    "6": "Bonus uduşu və bonus növü təsadüfi olaraq aşağıdakılardan müəyyən edilir:",
    "7": "Slotlarda depozit bonusu",
    "8": "Slotlarda frispinlər",
    "9": "İdman üçün frispinlər"
  },
  NezlobLanding: {
    forDeposit: "depozitdə",
    title: "Zarafatlar bitdi!"
  },
  NotCalculated: "Hesablanmamışdır",
  NotSingleActionCurrentlyHeld: "Hazırda heç bir aksiya keçirilmir",
  OlimpCasino: "Olymp kazino",
  OpenFullVersion: "Tam versiyanı açın",
  PaymentMethods: "Ödəniş üsulları",
  PlayEveryDay: "Hər gün oynayın",
  PromoAvailableFrom: "Aksiyada {date}-ci ildən etibarən iştirak etmək olar",
  PromoAvailableFromTo: "Aksiyada {date1}-ci ildən {date2}-ci ilədək iştirak etmək olar",
  PromoEnded: "Aksiya {date}-ci il tarixində bitdi",
  Promotions: "Aksiyalar",
  PromotionsWillDisplayedHere: "Cari aksiyalar burada əks olunacaq",
  QuestionAndAnswer: "Sual - Cavab",
  RulesAcceptingBets: "Olymp bukmeker kontorunun mərclərinin qəbulu Qaydaları",
  RulesOfPromotion: "Aksiyanın qaydaları",
  RulesSingle: "Qaydalar",
  SelectTypeSystem: "Sistem tipini seçin",
  Soon: "Tezliklə",
  Statistics: "Statistika",
  StayTuned: "Bizimlə qalın",
  TableContents: "Mündəricat",
  TheSearchHasNotGivenAnyResults: "Axtarış nəticə vermədi",
  ToDisableYouNeedToConfirmYourPhoneAndEmail: "Deaktiv etmək üçün telefonunuzu və elektron poçtunuzu təsdiqləməlisiniz",
  ToMain: "Əsas səhifəyə",
  ToUp: "Yuxarı",
  TypeBonusesAndPromotions: "Bonus və aksiyaların növü",
  UntilTheNextBonus: "Növbəti bonusadək",
  UploadDocuments: "Yüklənmiş fayllar",
  Version: "versiya",
  WeAreOnSocialMedia: "Biz sosial şəbəkələrdə",
  WeOnSocialMediaFull: "Biz sosial şəbəkələrdə",
  WorldCup: "Dünya Kuboku-2022",
  YouDataProtected: "Şəxsi məlumatlar və vəsaitlər təhlükəsizlikdədir",
  YourBonus: "Sizin bonusunuz",
  aboutBonus: "Bonus haqqında daha ətraflı",
  acceptWithModifiedOdds: "Dəyişdirilmiş əmsallarla qəbul etmək",
  acceptWithModifiedTotals: "Dəyişdirilmiş totallar/foralarla qəbul etmək",
  accountApprove: "Hesab qorunur",
  accountNotApprove: "Hesab qorunmur",
  action: "Hərəkət",
  activate: "Aktivləşdirmək",
  activateBonus: "Bonusu aktivləşdirmək",
  activateFastBets: "Sürətli mərcləri aktivləşdirin",
  activatingPromoCode: "Promokodun aktivləşdirilməsi",
  active: "Aktiv",
  activeBonusErr: "Bonusun aktivləşdirilməsi üçün ___ -dən az olmayan məbləğdə depozit daxil etmək qalıb",
  activeWager: "Cari bahis",
  add: "Əlavə etmək",
  addToBasket: "Səbətə əlavə etmək",
  addYourFavoriteGames: "Bunun köməyi ilə sevimli oyunlarınızı seçilmişlərə əlavə edin",
  addingDogeCoin: "Добавляем монету Doge",
  additionalInfo: "Əlavə məlumat",
  addressCryptoWallet: "Kripto pulqabının ünvanı",
  addressWallet: "Pulqabının ünvanı",
  afterInstallApp: "Tətbiqin quraşdırılmasına görə {0} bonus aldınız",
  agreeTermsAndConditions: "Mən {0} ilə razıyam və təsdiq edirəm ki, yaşım 18-dən yuxarıdır",
  all: "Hamsini gör",
  allDepositMethods: "Bütün hesab artırma üsulları",
  allGames: "Bütün oyunlar",
  allMessages: "Cəmi",
  allMessagesButton: "Mesajlara keçin",
  allMessagesText: "Bütün mesajlar",
  allPromo: "Bütün aksiyalar",
  allRequiredFieldsMustBeFilled: "Bütün zəruri xanalar doldurulmalıdır",
  allTypes: "Bütün növlər",
  allWithdrawMethods: "Bütün çıxarış üsulları",
  all_right: "Bütün hüquqlar qorunur.",
  alreadyHasAccount: "Hesab artıq mövcuddur",
  always: "Hər zaman",
  amountOnAccount: "Hesabdakı məbləğ",
  anUnexpectedErrorOccurred: "Gözlənilməz xəta baş verdi!",
  antifraud: {
    five: "Müştərilərin çoxpilləli yoxlanması (İP üzrə yoxlama, sistemin parametrlərinin əldə edilməsi, dolayı göstəricilərin yoxlanması); Müştərinin telefon nömrəsinin yoxlanması; Oyunçunun davranışının mütəxəssis tərəfindən analiz edilməsi; Fırıldaqçılıqdan qorunma sistemi ödəniş məlumatlarının, ödəniş tarixçələrinin və istifadəçilərin qara siyahısının dərindən yoxlanması üçün nəzərdə tutulan 100-dən çox filtrə malikdir; Müştəri vəsaitlərin çıxarılması mərhələsində bizim nəzarət xidməti tərəfindən yekun yoxlamadan keçirilir.",
    four: "Əsas xüsusiyyətlər",
    one: "Fırıldaqçılıqdan qorunma",
    three: "İnternet ödənişləri xidmətlərinin aparıcı təchizatçıları ilə əməkdaşlıq edərək biz onlayn biznesi etibarlı şəkildə həyata keçirmək və istifadəçilərimizin özəl məlumatlarının, habelə bütün ödəniş məlumatlarının təhlükəsizliyinə zəmanət vermək üçün əlimizdən gələn hər şeyi edirik. Bizim ödəniş əməliyyatlarının məlumat bazalarının idarəetməsi sahəsində onillik təcrübəmiz Avento AntiFraud Tool alətini həqiqətən kredit kartları üzərində fırıldaqçı əməliyyatlar əleyhinə güclü və rahat vasitəyə çevirir.",
    two: "Avento AntiFraud Tool mərc oyunlarının onlayn mühitində fırıldaqçı əməliyyatların qarşısını alan fırıldaqçılıqdan qorunmaq üçün işlənib hazırlanmış güclü alətdir. Bu bizə öz oyun müəssisələrimizdə kredit kartları üzərində fırıldaqçı əməliyyatların miqdarını xeyli azaltmağa imkan verir."
  },
  app: "Tətbiq",
  appOlymp: "Olymp tətbiqi",
  apply: "Tətbiq etmək",
  approve: "Təsdiq edirəm",
  approvePhoneBySms: "Nömrəni SMS vasitəsilə təsdiqləmək",
  approvePhoneByTelegram: "Nömrəni Telegram vasitəsilə təsdiqləmək",
  approved: "Qəbul edildi",
  approvedSecond: "Təsdiq edilib",
  approvingWithdraw: "Vəsait çıxarışının təsdiqi",
  april: "aprel",
  areYouSureDeposit: "Hesabı artırdığınıza əminsiniz?",
  areYouSureToDeclineBonus: "Bonusdan imtina etmək istədiyinizə əminsiniz?",
  areYouSureYouWantToSell: "Mərci satmaq istədiyinizə əminsiniz",
  attach: "Sənədləri əlavə edin",
  attachDocumentsToVerifyAccount: "Yoxlamanı tamamlamaq və vəsaiti çıxarmaq üçün sənədləri əlavə edin",
  attempt: "Cəhd yoxdur | 1 Cəhd | {count} Cəhd",
  august: "avqust",
  authApproveText: "Robot olmadığınızı yoxlamaq üçün 'Təsdiq edirəm' düyməsini sıxın",
  authFromSocial: "Sosial şəbəkələr vasitəsilə daxil olun",
  authorization: "İstifadəçinin qeydiyyat məlumatlarının yoxlanması",
  authorizationRequired: "Ödənişli oyun istifadəçinin qeydiyyat məlumatlarının yoxlanmasını tələb edir!",
  availabilityWallet: "{wallet} pripto pulqabı tələb olunur",
  available: "Mövcuddur",
  availableBonuses: "Qazanıla bilən bonuslar",
  availableOnlyGameForMoney: "Yalnız pul üçün oyun mümkündür",
  back: "Geriyə",
  backToHome: "Əsas səhifəyə qayıtmaq",
  backToLogin: "Giriş səhifəsinə qayıtmaq",
  backToOneStep: "İlk addıma qayıtmaq",
  balance: "Balans",
  balanceAfterTopUp: "Hesabı artırdıqdan sonra balans: {value}",
  balanceAfterWithdraw: "Çıxarışdan sonra balans: {value}",
  balanceBK: "BK balansı",
  balanceBKRefreshSuccessfully: "BK balansı uğurla yeniləndi",
  balanceCasino: "Kazinonun balansı",
  balanceCasinoRefreshSuccessfully: "Casino balansı uğurla yenilənir",
  balanceSwitchByWithoutBalance: "Bonus balansına keçid yalnız real balansda vəsaitlər olmadıqda bonus oyunları oynayarkən avtomatik olaraq baş verir",
  balances: "Balanslar",
  bankCard: "Bank kartı",
  basketBets: "Səbət",
  behind: "üçün",
  bet: "Mərc",
  betHistory: "Mərclərin tarixçəsi",
  betID: "Mərcin identifikasiya kodu",
  betSoldFor: "Mərc {count} məbləğə satıldı",
  betsAreSuspended: "Mərclərin qəbulu dayandırılır",
  betsNotAccessForBonusBalance: "İdman mərcləri bonus balansından mümkün deyil!",
  bettingHistory: {
    bet: "Mərc",
    coefficient: "Əmsal",
    dataOfBet: "Mərc məlumatları",
    findOutTheScore: "Hesabı öyrənmək",
    numberAndDateOfBet: "Mərcin nömrəsi və tarixi",
    payout: "Ödəniş",
    status: "Status"
  },
  bidAddedToCart: "Mərc səbətə əlavə edildi",
  bidDeletedToCart: "Mərc səbətdən silindi",
  bonus: "Bonus",
  bonusActivated: "Bonus aktivləşdirilib",
  bonusActivation: "Bonusun aktivləşdirilməsi",
  bonusBalance: "Bonus. balans",
  bonusBalanceOnly: "Bonus balansı ilə oynamaq üçün bonus oyununu işə salın",
  bonusCondition: "Bonusun şərtləri",
  bonusNotActivated: "Bonus aktivləşdirilməyib",
  bonusOnFirstDeposit: "İlk depozitdə 100%<br/> bonus",
  bonusQuestion: "Siz hələ xoş gəldin bonusunu almamısınız?",
  bonusSport: {
    block1: {
      li1: "olymp.casino saytında qeydiyyatdan keçin.",
      li2: "Bonusu aktivləşdirmək üçün Şəxsi kabinetinizdə “Bonuslar” bölməsinə keçin və təklifi aktivləşdirin.",
      li3: "Bir ödənişlə 500 KZT / 12 000 UZS və ya daha çox məbləğdə depozit qoyun.",
      li4: "Hesab artırıldıqdan sonra bonus avtomatik olaraq hesaba daxil ediləcək və \"İdman\" bölməsində mərc etmək üçün kuponunuzda əlçatan olacaq.",
      title: "Bonusunuzu necə əldə etmək olar:"
    },
    block2: {
      li1: "İstifadəçinin yalnız bir bonus hüququ var.",
      li2: "Pulsuz mərc yalnız idmanda istifadə edilə bilər. Kuponunuz ən azı 3 və maksimum 10 əmsalı olan tək mərc olmalıdır.",
      li3: "Oyunçu öz hesabına yalnız qazanan hissəni alır.",
      text: "Məsələn: 3 əmsalı ilə 500 məbləğində pulsuz mərc. Oyunçu hesabına 3*500-500 = 1000 alır.",
      title: "Şərtlər və müddəalar:"
    },
    block3: {
      li1: "Pulsuz mərc üçün mərc tələbləri 7 gün ərzində yerinə yetirilməlidir, əks halda bonusun müddəti bitəcək.",
      li10: "Olymp.casino istənilən vaxt əvvəlcədən xəbərdarlıq etmədən təklifin şərtlərini dəyişdirmək, təklifi ləğv etmək və ya bərpa etmək və ya iştirakdan imtina etmək hüququna malikdir.",
      li11: "Olymp.casino istifadəçilərin bu və ya hər hansı digər təklifdə iştirakını məhdudlaşdıra və ya imtina edə bilər.",
      li12: "Bir müştəri, ailə, ünvan, ümumi kompüter, ümumi IP ünvanı, eləcə də elektron poçt ünvanı, bank hesabı rekvizitləri, kredit kartı və ödəniş sisteminin hesabı barədə məlumat daxil olmaqla hər hansı eyni hesab məlumatı üçün yalnız bir bonusa icazə verilir. Bu bonus təklifindən hər hansı sui-istifadə hesabın bağlanması ilə nəticələnəcək.",
      li13: "Olymp.casino istənilən vaxt bu təklifi dəyişdirmək və ya ləğv etmək hüququnu özündə saxlayır.",
      li14: "Bonusu qəbul etməklə müştəri bonus şərtləri, həmçinin Olymp.casino-nun ümumi qaydaları və müddəaları ilə razılaşır.",
      li2: "Uduşlarınızı çıxarmaq üçün siz minimum 500 KZT / 12 000 UZS depozit qoymalı və x1 mərcini yerinə yetirməlisiniz.",
      li3: "Ləğv edildiyi və ya geri qaytarıldığı halda mərc itki kimi hesablanır.",
      li4: "Yarım itki zamanı (asiya forası və total) mərc itki kimi hesablanır.",
      li5: "Yarım qələbə zamanı (asiya forası və total) - mərc məbləği istisna olmaqla, adi mərc kimi hesablanır.",
      li6: "Mərc hesablandıqdan sonra vəsait balansınıza köçürülür.",
      li7: "Pulsuz mərcdən qismən istifadə etmək olmaz. (yəni 500 pulsuz mərciniz varsa, 500 mərc etməlisiniz. Müxtəlif kuponlar üçün 250 - 250 qəbul edilmir).",
      li8: "Təklif digər reklam xarakterli və ya xüsusi təkliflərlə birlikdə istifadə edilə bilməz.",
      li9: "Birdən çox hesaba icazə verilmir və birdən çox hesab aşkar edilərsə, bu, bütün hesabın dayandırılması ilə nəticələnəcək.",
      title: "Digər şərtlər:"
    },
    title: "Olymp.Casino-ya qoşulmaq üçün ən yaxşı vaxt indidir, çünki biz hər bir yeni istifadəçiyə 500 KZT / 12 000 UZS pulsuz idman mərcini təklif edirik."
  },
  bonusTimeLeft: "Hərəkət etmək vaxtıdır",
  bonusWager: "Bonus bahisi:",
  bonuses: "Bonuslar",
  bookmakerShort: "BK",
  "break": "Fasilə",
  bronze: "Bürünc",
  btn: "Kassa",
  byDefault: "İlkin parametrlər",
  byDefaultDown: "Əlifba üzrə (A-Z)",
  byDefaultUp: "Əlifba üzrə (Z-A)",
  bySport: "İdman növləri üzrə",
  cabbage: {
    eight: "əgər oyunçu 5 gündən ibarət tam dövrəni başa çatdırıbsa.",
    eighteen: "Mükafat {number}",
    eleven: "Aksiyada iştirak etməklə siz bu aksiyanı keçirən onlayn kazinonun təyin etdiyi bu qaydalarla və şərtlərlə avtomatik olaraq razılaşırsınız.",
    fifteen: "Məqsədlər və mükafatlar",
    five: "Gündəlik irəliləyişlə və gündəlik məqsədlərin yerinə yetirilməsi ilə birlikdə mükafatlar da artır. Gündəlik irəliləyişi qoruyub saxlamaq, dövrənin növbəti gününə keçmək imkanı qazanmaq və daha iri mükafatlara iddia etmək üçün iştirakçı gündəlik məqsədi heç olmazsa bir dəfə yerinə yetirməlidir.",
    four: "\"Gündəlik mükafatlar\" kampaniyası hər biri 5 təqvim gününə qədər davam edən dövrələr şəklində keçirilir və bu zaman gündəlik məqsədi 3 dəfəyə qədər yerinə yetirmək imkanı verilir.",
    fourteen: "Xətalar baş verdikdə, bütün uduşlar ləğv edilir.",
    list: "Qaydalar və şərtlər:",
    nine: "Aksiyada iştirak etmək üçün əlavə depozitlər qoymaq və ya əmanətlər etmək tələb olunmur.",
    nineteen: "Gündəlik məqsəd 1 dəfə yerinə yetirilib",
    one: "Pul ekvivalentində ən yüksək sort kələm yığımına artıq başlamaq vaxtıdır!",
    seven: "əgər oyunçu bir günü buraxıbsa və ya gündəlik məqsədi heç olmazsa bir dəfə yerinə yetirməyibsə;",
    seventeen: "Gündəlik məqsədlər",
    six: "İştirakçının gündəlik mükafatlar dövrəsi 2 halda birinci günə qədər azaldılır:",
    sixteen: "Dövrənin bir günü",
    ten: "Yalnız həqiqi pullarla oynamaqla aksiyada iştirak etmək mümkündür.",
    thirteen: "{company} mükafatları ödəmədən, aksiyanı istənilən vaxtda qeyri-müəyyən müddətə dayandırmaq, habelə əvvəlcədən xəbərdarlıq etmədən, qaydaları dəyişdirmək hüququnu özündə saxlayır.",
    three: "İştirak etmək üçün Booongo provayderinin oyunlarından hər hansı birini oynamaq lazımdır. Mükafat fondu hər iştirakçı üçün 1160 avroya qədərdir. Ümumi məbləğ bütün kampaniya (2 tam dövrə) müddəti ərzində iştirakçının bütün mümkün gündəlik məqsədləri yerinə yetirdiyi təqdirdə maksimal ümumi şəxsi mükafat fondu kimi hesablanır. Ən gözəl mükafat hər dövrənin sonuncu günündə olacaq!",
    twelve: "İştirak qaydaları və şərtləri yalnız {company} qərarı əsasında istənilən vaxtda dəyişdirilə bilər.",
    twenty: "Gündəlik məqsəd 2 dəfə yerinə yetirilib",
    twentyFive: "hər iştirakçı üçün 1160 avroya qədərdir!",
    twentyFour: "Mükafat fondu",
    twentyOne: "Gündəlik məqsəd 3 dəfə yerinə yetirilib",
    twentySix: "Tarix və vaxt",
    two: "İştirak etmək üçün Booongo provayderinin oyunlarından hər hansı birini oynayın və gündəlik məqsədlərə nail olun."
  },
  cabinet: "Şəxsi kabinet",
  calculated: "Hesablanmış",
  calculationID: "Hesablaşma üçün identifikasiya kodu",
  canNotChangeCurrency: "Valyuta dəyişdirilə bilməz",
  canSelectSavedData: "Siz saxlanan məlumatları seçə bilərsiniz",
  cancel: "Ləğv et",
  cancelBonus: "Bonusu ləğv edin",
  cancelBonusConfirm: "Bonusu ləğv etmək istədiyinizə əminsiniz? Ləğv edildikdə, bütün bonus vəsaitləri ləğv olunacaq",
  cantEnterTheCode: "Kodu daxil edə bilmirsiniz?",
  carriedOut: "Yerinə yetirilib",
  cashBackSum: "Ani Cashback-in məbləği",
  cashBoxApproveCode: "Təsdiq kodu",
  cashBoxApproveCodeHint: "Kassir vəsaitin çıxarılmasını təsdiqləməlidir",
  cashBoxDeliveryText: "Rahatlığınız üçün, hesabın artırılması/çıxarış məbləği {0} və daha yuxarıdırsa, sizə kuryer gələ bilər. Kuryeri çağırmaq üçün bizə teleqramda yazın, login {1}",
  cashbackTitle: "Cashback",
  cashboxAddress: "Kassanın ünvanı",
  casino: "Kazino",
  casinoBonus: "Bonus kazino",
  casinoLogin: "{name}-ə giriş",
  categoryFromAtoZ: "A-dan Z-dək kateqoriya",
  change: "Dəyişmək",
  changeData: "Məlumatları dəyişmək",
  changeEmail: "Poçtu dəyişmək",
  changeMethod: "Üsulu dəyişmək",
  changePassword: "Şifrəni dəyişmək",
  changePhone: "Nömrəni dəyişmək",
  changeStatusCode: "Kodun statusunu dəyişmək",
  changeTheEmail: "Email dəyişmək",
  changeWallet: "Pul kisəsini dəyişmək",
  changingEmail: "E-mail dəyişməsi",
  changingPhone: "Nömrənin dəyişməsi",
  checkRobotText: "Sizin robot olmadığınız yolxamaq üçün „Təsdiq edirəm“ düyməsini sıxın",
  checking: "Yoxlanılır",
  chooseComfortableAddress: "Daxil olmaq üçün əlverişli bir ünvan seçin",
  chooseDepositViaCryptocurrencyMethod: "\"Kriptovalyuta vasitəsilə balansın artırılması\" üsulunu seçin",
  chooseVariantOrContinueEnter: "Variant seçin və ya daxil etməyə davam edin",
  chooseVerificationMethod: "Kodla çıxarış təsdiqini söndürmək üçün üsulu seçin",
  clear: "Təmizləmək",
  clearFavorites: "Seçilmişləri silmək",
  clickCheckoutInHeaderOfSite: "Saytın yuxarı hissəsində „Xəzinə“ düyməsini sıxın",
  clickHome: "\"Evə ekranına\" sıxın",
  clickOnTheOddsYouLike: "Bəyəndiyiniz əmsallara klikləməklə, sadəcə olaraq açılan pəncərədə sürətli mərclər edin:",
  clickSelectFrontCoin: "Нажмите “Выбрать” напротив монеты, например “Tether TRC20”",
  clickShare: "\"Bölüşmək\" sıxın",
  clickToAttache: "Fayl əlavə etmək üçün klikləyin",
  clickTopMenuToBuyCrypto: "Нажмите в верхнем меню “Покупка крипто” и выберите способ оплаты “С банковской карты”. Мин. сумма - 10.40 USD ",
  close: "Bağlamaq",
  code: "Kod",
  codeAlreadySendFillIt: "Sizə təsdiq kodu göndərildi, onu giriş sahəsinə daxil edin",
  codeIsWrong: "Kod düzgün deyil",
  codeSend: "SMS kod nömrəyə göndərildi",
  codeSendToEmail: "Kod poçta göndərildi",
  codeSendToPhone: "Kod nömrəyə göndərildi",
  codeSendToTelegram: "Kod Telegram-da bot vasitəsilə göndərildi",
  codeVerificationDisabled: "Doğrulama kodu deaktiv edildi",
  codeVerificationEnabled: "Kodla təsdiq aktiv edildi",
  coinSelection: "Sikkə seçimi",
  comboBoostBonus: {
    button: "Oynamaq",
    content_title: "Combo Boost-dan necə istifadə etmək olar:",
    good_luck: "Olymp.casino sizə böyük qələbələr arzulayır!",
    range_left_title: "Hadisələrin sayı",
    range_right_title: "Əmsal.",
    step_one: "Addım 1:",
    step_one_description: "Elə indi uduşlu ekspressinizi toplamağa başlayın və artan əmsalları necə əldə etməyinizə diqqət yetirin.",
    step_three: "Addım 3:",
    step_three_description: "Seçiminizi etdikdən sonra mərcinizi qoyun! Bonus avtomatik olaraq yekun əmsalınızı artıracaq. Siz mərcinizi \"Mənim mərclərim\" bölməsində yoxlaya bilərsiniz. O, COMBOBOOST markeri ilə vurğulanacaq.",
    step_two: "Addım 2:",
    step_two_description: "Ekspress mərcinizi toplamağa davam edin və bonus artımınızı izləyin.",
    welcoming_range_title: "Əmsalınızı öyrənin.",
    welcoming_text: "Olymp.casino-da bütün yeni müştərilər üçün əla xəbərlər var! İşləyib-işləmədiyini görmək üçün bu funksiyanı özünüz sınayın! Bonusumuzun köməyi ilə yekun əmsalınızı artırmaq üçün əmsalı 1.5 və daha yüksək olan 2 və ya daha çox hadisəyə sürətli mərc edin. Nəzərə alın ki, ekspresdə nə qədər çox hadisə baş versə, bonusunuz bir o qədər çox olacaq.",
    welcoming_title: "EKSPRESS-də daha çox tədbir - daha çox Bonus!"
  },
  commission: "Komissiya:",
  competitionAction: "Qeyd olunan oyunlardan birini oynamaqla turnirdə iştirak edin",
  competitionMembers: "turnirin iştirakçıları",
  competitionParticipants: "İştirakçıların siyahısı burada göstəriləcək",
  competitionWinners: "Qaliblərin siyahısı burada göstəriləcək",
  competitions: "Bütün turnirlər",
  competitionsGames: "Turnir",
  competitors: "{count} turnir iştirakçısı",
  completeRegistration: "Qeydiyyatı tamamlamaq",
  completeSecuritySettings: "Şəxsi məlumatların və vəsaitlərin təhlükəsizliyininin sazlanmasını bitirin",
  completeSignIn: "Avtorizasiyanı tamamlamaq",
  completed: "Turnir başa çatıb:",
  conductError: "Xəta",
  confirm: "Təsdiqləmək",
  confirmData: "Məlumatları təsdiqləmək",
  confirmInformation: "Məlumatı təsdiqləmək",
  confirmPersonalData: "Mən şəxsi məlumatlarımın düzgünlüyünü təsdiq edirəm və bu məlumatın dəyişdirilə bilməyəcəyini başa düşürəm",
  confirmPhoneNumber: "Telefon nömrəsini təsdiqləyin",
  confirmPhoneThroughTelegram: "Telegram tətbiqinə keçin və təhlükəsiz vəsait çıxarışı üçün telefon nömrənizi təsdiqləyin",
  confirmationCode: "Təsdiq kodu",
  confirmationEmail: "E-poçtun təsdiqlənməsi",
  confirmationPhone: "Telefonun təsdiqlənməsi",
  confirmed: "Təsdiqlənib",
  congratulationsTrustWalletCreated: "Поздравляем! Кошелек Trust Wallet создан!",
  contact: "əlaqə saxlayın",
  continueSecuritySetup: "Təhlükəsizlik parametrlərinə qayıtmaq",
  converting: "avtomatik olaraq çevrilir",
  copeAddressMemo: "Memo uğurla kopyalandı",
  copeAddressWallet: "Pulqabı ünvanı uğurla kopyalandı",
  copeAddressWalletNew: "Pulqabınızın ünvanı uğurla kopyalandı",
  copeCode: "Kod uğurla kopyalandı",
  copeSumText: "Məbləğ uğurla kopyalandı",
  copy: "Kopyalamaq",
  copyAddress: "Ünvanı kopyalamaq",
  copyCode: "Kodu kopyalamaq",
  copyTheAddress: "Ünvanı kopyalayın",
  countries: {
    bangladesh: "Banqladeş",
    kazakhstan: "Qazaxıstan",
    kyrgyzstan: "Qırğızıstan",
    russia: "Rusiya",
    uzbekistan: "Özbəkistan"
  },
  country: "Ölkə seçimi",
  countryNotFound: "Ölkə tapılmadı, düzgün yazıldığını yoxlayın",
  countrySelect: "Ölkə seçimi",
  coupon: "Kupon",
  couponContainsDependentOutcomes: "Kuponda asılı nəticələr var",
  createWalletInTrustWallet: "Создайте кошелёк в Trust Wallet",
  cryptoMemo: "Memo",
  cryptoTournament: "Kripto-turnir",
  cryptoWallerSuccessChanged: "Pulqabının ünvanı uğurla dəyişdirildi",
  cryptoWallet: "Kripto pulqabı",
  cryptocurrency: "Kriptovalyuta",
  currency: "Valyuta",
  current: "Cari",
  currentBalanceIsLessThanTheWithdrawalAmount: "Bütün ödəniş üsulları mövcud deyil, cari balans əməliyyatı başa çatdırmaq üçün minimum məbləğdən azdır",
  currentRates: "Cari mərclər",
  customerSupport: "müştəri xidməti tərəfindən",
  customizeDisplayedCoins: "Для настройки отображаемых монет нажмите на ползунки в правом верхнем углу, на странице добавления токенов в строке поиска введите Doge. Активируйте монету Doge, нажав на ползунок напротив монеты",
  cyrillicInPasswordNotAvailable: "Şifrədə kiril hərfləri yolverilməzdir",
  data: "Tarix",
  dataNotSpecified: "Məlumatlar göstərilməyib",
  date: "Tarix",
  dateFrom: "Tarixdən",
  dateOfTransaction: "Əməliyyat tarixi",
  dateTo: "Tarixədək",
  deadline: "Başa çatmasına qalıb",
  december: "dekabr",
  decline: "Rədd edildi",
  demo: "Demo",
  deposit: "Depozit",
  depositAccount: "Hesabı artırmaq",
  depositBK: "BK vasitəsilə hesabı artırmaq",
  depositBonus: "Balans artimi zamani {bonus} bonus",
  depositForBonus: "Bonus almaq üçün {sum} və daha yuxarı məbləğdə depozit qoyun",
  depositNoun: "Hesabın artırılması",
  depositRequired: "<span class='bonus-item__sum'>{sum}</span> yuxarı depozit qoymalısınız",
  description: "Təsvir",
  descriptions: {
    gameGroups: {
      "GamesByGroup\/slot": "Onlayn slotlar ➔ ✓pulla, ✓ödənişsiz və ✓qeydiyyatsız oynayın. {company} kazinosu ✓rəsmi istehsalçılardan ✓səxavətli bonuslarla və ✓müxtəlif mövzularda ✓pulsuz ✓populyar ✓müasir oyun avtomatlarını təqdim edir."
    }
  },
  details: "Daha ətraflı",
  docsWasApproved: "Sənədlər uğurla təsdiqləndi",
  docsWasDeclined: "Sənədlər yoxlamadan keçmədi",
  documentAttacheMessage: "24 saat ərzində onları yoxlayacağıq. Bundan sonra bütün ödəniş üsulları sizin üçün əlçatan olacaq.",
  documentAttacheSuccess: "Sənədləriniz uğurla göndərildi.",
  documentDeleteSuccess: "Sənədlər uğurla silindi",
  documentNumber: "Sənədin nömrəsi",
  documentUpload: "Sənədlərin yüklənməsi",
  done: "Hazırdır!",
  doneThresholdConditions: "Depoziti mərc etmək üçün şərtlər yerinə yetirilmişdir",
  download: "Yükləmək",
  downloadApp: "Tətbiqi yükləmək",
  downloadOlimpApp: "Olymp tətbiqi yükləmək",
  download_app: "Olymp tətbiqi yükləmək",
  dropswins: {
    eight: "Təsadüfi bir anda 9000€ məbləğində pul mükafatları oynanılır. Qazanmaq üçün oynayın!",
    eighteen: "Şərtlər və qaydalar",
    eleven: "Həftəlik Turnir Mükafatları Cədvəli (Adi Həftələr)",
    fifteen: "Gündəlik Mükafatlar Cədvəli",
    five: "GÜNDƏLİK",
    four: "TURNİR",
    fourteen: "Həftəlik Turnir Mükafatları Cədvəli (Adi Həftələr)",
    nine: "Həftəlik 4 dəfə 62.000 avroluq turnirlər",
    nineteen: " 1. Bu Pragmatic Play TM şəbəkə kampaniyasıdır. Bu kampaniya 11/02/2021 - 17/11/2021 CET (01:01 02/11/2021 - 00:59 11/18/2021 EET) tarixləri arasında davam edir.<br> 2.  Kampaniya hər mərhələnin 4 həftə davam etdiyi 10 mərhələdə aparılır.<br> 3. Bütün aksiya üçün ümumi mükafat fondu 40 x 62,000€ həftəlik turnirlərdən və 40 x 63,000€ həftəlik mükafat çəkilişlərindən ibarət olub 4.000.000€ təşkil edir.<br> 4. Aşağıda bu aksiyanın 7-ci mərhələsinin şərtləri verilmişdir. Nəzərə alın ki, turnirin mexanikası mərhələdən asılı olaraq dəyişir.<br> 5. Uduşlu şəbəkə kampaniyasının hər hansı bir Turnirində və ya Mükafat Çəkilişində iştirak etmək üçün oyunçular hər hansı iştirak edən oyunu açmalı və iştiraklarını təsdiqləməli / şərtlərlə razılaşmalıdırlar.<br> 6. Dörd (4) həftəlik turnirlər və mükafat çəkilişləri aşağıdakı kimi olacaq:<br> 27-ci həftə: 11.08.2021 20:01 – 18.08.2021 19:59 EET<br> 28-ci həftə: 18.08.2021 20:01 – 25.08.2021 19:59 EET<br> 7. Seçmə Oyunlar:<br> Wolf Gold™, Mustang Gold™, Sweet Bonanza™, John Hunter and the Tomb of the Scarab Queen™, Great Rhino Megaways™, John Hunter and the Book of Tut™, The Dog House™, The Dog House Megaways™, Chilli Heat™, Fruit Party™, Big Bass Bonanza™, Madame Destiny Megaways™, Gems Bonanza™, Wild Wild Riches™, Wild West Gold™, Gates of Olympus™, Power of Thor Megaways™, Buffalo King Megaways™, The Hand of Midas™, Floating Dragon Hold & Spin™, The Magic Cauldron – Enchanted Brew™, Heart of Rio™, Dragon Hot Hold and Spin™, Lucky Lightning™, 5 Lions Megaways™ ",
    one: "Pragmatic Play-ə aid hər kəsin qalib ola biləcəyi Drops & Wins şəbəkə turnirinə qoşulun!",
    seven: "Ən yüksək tək spin qazancını əldə etməklə liderlər cədvəlinin zirvəsinə qalxın.",
    seventeen: "Bu turnir, qazanc vurma əmsalını hesablayan bir mexanizmdən istifadə edir ki, turnirdə iştirak mərcin həcmindən asılı olmayaraq bütün oyunçular üçün ədalətli olsun. Məsələn, 2 avro mərc etsəniz və 10 avro qazansanız, qazanc vurma əmsalı beşə bərabər olacaq. Bu halda beş xal qazanacaqsınız. Ən yüksək tək spin qələbəsi ilə, ən yaxşı 1200 Lider sırasına qalxın.",
    six: "Təklifdəki oyunları açın, turnirə qoşulun və oynamağa başlayın (minimum mərc məbləği 0.50 avro).",
    sixteen: "Turnirdə və mükafat çəkilişlərində avtomatik iştirak etmək üçün kampaniyaya yalnız bir dəfə qoşulmağınız kifayətdir.",
    ten: "Həftəlik 4 dəfə 63.000 avroluq uduş tirajı",
    thirteen: "Mükafat",
    three: "OYNA",
    twelve: "Yer",
    twenty: "Həftəlik turnirlər",
    twentyfour: "Ani kəşbək",
    twentyone: " 1. Liderlər cədvəli xallar əsasında formalaşdırılır və xallar, mərc miqdarı nəzərə alınmaqla turnirdə iştirak edən hər hansı oyunda qazanılan bir spinə görə ən yüksək qazanc əsasında hesablanır.<br> 2. Liderlər cədvəli real zaman rejimində yenilənir və oyunçular istənilən turnir oyununda oynayarkən istənilən vaxt liderlər cədvəlinə baxa bilərlər.<br> 3. İki (2) və ya daha çox oyunçunun turnir cədvəlində eyni mövqedə bitirməsi halında, daha yüksək yer bu qədər xalı ilk toplayan oyunçuya veriləcək.<br> 4. Mükafatlar oyunçulara sabit məbləğ şəklində ödənilir .<br> 6. Həftəlik mükafat fondunda ümumi məbləği 62.000 avro olan 1200 pul mükafatı var.<br> 7. YER - HƏFTƏLİK MÜKAFATLAR<br> 1. €10,000<br> 2. €5,000<br> 3. €2,000<br> 4-10. €1,000<br> 11-20. €500<br> 21-50. €200<br> 51-100. €100<br> 101-300. €50<br> 301-600. €20<br> 601-1200. €10 ",
    twentythree: " 1. Aksiyanın hər həftəsində yeddi (7) gündəlik mükafat çəkilişi var.<br> 2. Hər aksiya zamanı, şərtlərə uyğun gələn bir (1) spin, mükafat fondundan bir (1) mükafat qazandıra bilər.<br> 3. Mükafatlar təsadüfi əsaslarda oynanılır. Qaydalar və mükafat cədvəlləri turnirdə iştirak edən oyunlarda mövcuddur. Mükafatlar cədvəli real zaman rejimində yenilənərək, cari mövqeyi və həmçinin qalan mükafatların sayını göstərir .<br> 4. Mükafatlar, iştirak edən oyunların hər biri üçün \"Mükafatlar\" bölməsində göstərildiyi kimi ödənilir.<br> 5. Mükafatlar oyunçulara sabit məbləğ şəklində verilir.<br> 6. Hədiyyə oyununda iştirak etmək üçün minimum real pul mərci etməlisiniz: turnirdə iştirak edən oyun(lar) üçün 0.50 avro. Bir oyunçu hər gün bir neçə mükafat qazana bilər.<br> 7. Mükafatların oynanılması hər gün (i) 00:59=da EEST / EET və ya (ii) bütün mükafatlar verildikdən sonra (hansı birinci olarsa) bitir.<br> 8. Müəyyən bir gündəlik oynanılma üçün mükafat fondu tam olaraq paylanmadığı təqdirdə, artıq qalan vəsait, PragmaticPlay™-nin mülahizəsinə görə növbəti mərhələ üçün mükafat fonduna köçürüləcək.<br> 9. Həftəlik mükafat fondu ümumilikdə 63.000 avrodur, gündəlik mükafat fondunda isə ümumi 9000 avroluq 500 pul mükafatı və pulsuz raundlar var.<br> 10. Miqdar - Gündəlik Mükafatlar<br> 1 X €1.000<br> 2 X €500<br> 5 X €100<br> 12 X €50<br>  110 X €20<br> 370 X €10<br> 11. Qaliblər mükafatlarını pul şəklində alırlar. Pul mükafatları, turnir bitdikdən sonra avtomatik olaraq {baseLink} kazinosundakı oyun hesablarına köçürüləcək.<br> 12. {baseLink} istənilən vaxt aksiyanın şərtlərini dəyişmək və ya ləğv etmək hüququnu özündə saxlayır.<br> 13. {baseLink} -un ümumi qaydaları və şərtləri tətbiq olunur.<br> ",
    twentytwo: "Həftəlik mükafat çəkilişləri",
    two: "500.000€ mükafat fondu mərhələlər arasında bölüşdürülür - həftədə 125.000€! İştirak etmək üçün sadəcə aşağıdakı addımları yerinə yetirin!"
  },
  email: "Email",
  emailNeedValid: "Yoxlama kodu elektron poçtunuza göndəriləcək",
  emailSuccessfullyApproved: "E-mail uğurla təsdiqləndi",
  emptyGames: "Sizin üçün belə oyunlar tapmadıq",
  emptyPromoPage: "Cari aksiyalar burada əks olunacaq",
  ended: "Tamamlandı",
  engineeringWorks: "5 dəqiqədən sonra vebsaytda texniki işlər aparılacaq",
  english: "İngilis",
  enter: "Qoşulun",
  enterCode: "Kodu daxil edin",
  enterCodeFromEmail: "Elektron poçtunuzdan kodu daxil edin",
  enterCorrectPhoneNumber: "Düzgün telefon nömrəsini daxil edin",
  enterCryptoWallet: "Kripto pulqabını daxil edin",
  enterCryptoWalletOnProfilePage: "Uduşlarınızı almaq üçün şəxsi hesabınıza Doge kripto pulqabını daxil edin",
  enterGameName: "Oyunun adını daxil edin",
  enterGameNameOrProvider: "Provayder üçün oyun adını daxil edin",
  enterMoreCharacters: "Daha çox işarə daxil edin!",
  enterPromoCode: "Promo kodu daxil edin",
  enterSMS: "SMS kodu daxil edin",
  enterSixDigitCode: "Mobil tətbiqdən 6 rəqəmli kodu daxil edin",
  enterValidEmail: "Zəhmət olmasa düzgün elektron poçt daxil edin",
  enterWalletAddress: "Enter your Doge crypto wallet address and we will credit your tournament winnings to it.",
  enterYourBankCardDetails: "Bank kartının məlumatlarını daxil edin, ödəniş sisteminin şərtləri ilə razılaşın və sıxın “Ödəmək”",
  entrance: "Giriş",
  err404subtitle: "Sizi əsas səhifədə gözləyirik!",
  err404title: "Təəssüf ki, heç nə tapılmadı...",
  error: "Xəta",
  errorPasswordField: "Şifrədə rəqəmlər, böyük və kiçik hərflər olmalıdır",
  errorPaymentDataInitialization: "Ödəniş sistemini işə salarkən xəta",
  errorPaymentUrlInitialization: "Ödənişi təyin edilərkən xəta",
  errorWhileSendingCode: "Mesajı kodla göndərmək alınmadı, yenidən sorğulamağa cəhd edin",
  errorsWhileValidate: "Formanın yoxlanılması zamanı xətalar",
  euro_slot: {
    description: "Euro Slots 2024 onlayn oyunu yalnız {platform}-da oynayın - ən yaxşı rəsmi oyun slotları. Onlayn kazinolarda pulsuz və pulla oynayın.",
    end: "Turnir başa çatdı",
    "final": "Finala çıxın",
    inProgress: "Matç davam edir",
    mathPrize: "Matçın mükafat fondu:",
    onWallet: "hesaba",
    prize: "Ümumi mükafat fondu",
    "prize-short": "MÜKAFAT",
    prizeFond: {
      "1\/2": "1/2 finalın<p>mükafat fondu:</p>",
      "1\/4": "1/4 finalın<p>mükafat fondu:</p>",
      "1\/8": "1/8 finalın<p>mükafat fondu:</p>",
      "final": "Finalın <p> mükafat fondu:</p>"
    },
    rules: {
      "1": "Aksiya 13.06.2024 GMT +5 üzrə saat 00-00-dan 14.07.2024 GMT +5 üzrə saat 00-00 qədər davam edir",
      "2": "Turnirin ümumi mükafat fondu: 15000 $",
      "3": "Təqvimə uyğun olaraq, turnir şəbəkəsi boyunca hərəkət edən slotlar arasında döyüş keçirilir",
      "4": "Müəyyən bir aksiya oyununun qələbəsinə ən böyük töhfə verən istifadəçilər mükafat fondunu öz aralarında bölüşdürürlər",
      "5": "1/8 ({sum}) mərhələsinin cütləri üçün tarixlər:",
      "6": "1/4 ({sum}) mərhələsinin cütləri üçün tarixlər:",
      "7": "1/2 ({sum}) mərhələsinin cütləri üçün tarixlər:",
      "8": "Final tarixləri ({sum}):",
      "9": "Mükafatlar 24 saat ərzində avtomatik olaraq oyun hesabınıza köçürülür"
    },
    stage1: "<span> Qeydiyyatdan keçin </span> və “İŞTİRAK ETMƏK” düyməsini basın.",
    stage2: "İştirakçı oyunların <span>hər hansı birinə mərc edin</span> və xal qazanın.",
    stage3: "<span> Ən yaxşı oyunçular </span> ümumi mükafat fondunu bölüşəcəklər",
    stages: {
      "1\/2": "1/2 final",
      "1\/4": "1/4 final",
      "1\/8": "1/8 final",
      "final": "final"
    },
    stagesAtStart: {
      "1\/2": "Final başlamasına qalıb:",
      "1\/4": "1/2 finalın başlamasına qalıb:",
      "1\/8": "1/4 finalın başlamasına qalıb:",
      "final": "Final",
      pre: "1/8 finalın başlamasına qalıb:"
    },
    start: "Necə iştirak etmək olar",
    table: "Turnir cədvəli",
    title: "Euro Slots Tournament 2024 - {platformSite} Casino-da onlayn slot oynayın",
    winners: "Turnirin qalibləri"
  },
  events: "Hadisələr",
  exchangeRateInTenge: "Tenge ilə valyuta məzənnəsi",
  exit: "Çıxış",
  express: "Ekspress",
  expressCoef: "Ekspressin əmsalı",
  expressSystem: "Ekspress mərclər sistemi",
  failed: "Əməliyyat yerinə yetirilmədi",
  fastBet: "Sürətli mərc",
  fastbetDetailedDescription: "Sürətli mərc sizə yalnız iki kliklə tək mərclər qoymağa imkan verir. Son edilən mərc məbləğinin yaddaşda saxlanılması mərc prosesini daha da sürətləndirir.",
  fastbetSetting: "Sürətli mərc parametrləri",
  fastbetSum: "Sürətli mərc məbləği",
  favorite: {
    added: "Oyun seçilmişlərə əlavə edilib",
    removed: "Oyun seçilmişlərdən silinib"
  },
  favorites: "Seçilmiş",
  february: "fevral",
  fieldRequire: "Bu qrafa mütləq doldurulmalıdır",
  fileAttached: "Fayl əlavə edildi",
  fileNotAttached: "Fayl əlavə olunmayıb",
  fillInformation: "Məlumatı doldurun",
  fillProfileInfoForWithdraw: "Zəhmət olmasa vəsaiti çıxarmaq üçün şəxsi məlumatlarınızı doldurun.",
  fillRequiredInfoBelow: "Zəhmət olmasa aşağıda tələb olunan məlumatları doldurun",
  filter: "Filtr",
  filterByDate: "Tarix üzrə filtr",
  filtersText: {
    inTheNextSixHours: "Yaxın 6 saat",
    inTheNextTwentyFourHours: "Yaxın sutka ərzində",
    inTheNextTwoHours: "Yaxın 2 saat",
    nextThreeDays: "Yaxın 3 sutka ərzində",
    nextTwelveHours: "Yaxın 12 saat",
    nextWeek: "Yaxın həftə ərzində",
    today: "Bu gün",
    tomorrow: "Sabah",
    whenever: "Bütün müddətdə"
  },
  findOutAddressOfDogeWallet: "Узнайте адрес кошелька Doge",
  fine: "Yaxşı",
  firstAuthMessage: "Loqin və şifrənizlə SMS telefon nömrənizə göndərildi. Hesabınızı artırın və ilk uduşlarınızın ardınca gedin",
  firstDeposit: "İlk depozitinizə!",
  forCorrectGamePushRefresh: "Oyunu düzgün göstərmək üçün yeniləmə düyməsini basın",
  forEndCompetition: "Turnir bitənə qədər",
  forMoreInformation: "Ətraflı məlumat üçün",
  forStartCompetition: "Turnir başlayan qədər",
  forgotPassword: "Şifrənizi unutmusunuz?",
  fraud: "AML siyasəti",
  freeBetsButton: "Tanış olun",
  freeBetsCount: "Fribetlər mövcuddur:",
  freeBetsStepFour: "Mərc edin",
  freeBetsStepOne: "\"İdman\" bölməsini açın",
  freeBetsStepThree: "Tədbiri seçin",
  freeBetsStepTwo: "Kuponda \"Fribet\"i aktivləşdirin",
  freeBetsTitle: "İdman üçün \"fribet\"",
  freeSpinsInGame: "Oyunda pulsuz fırlatmalar",
  freespin: "Frispin",
  freespinsAvailable: "İstifadə oluna bilən frispinlər",
  from: "{date} tarixindən",
  fromAnySum: "İstənilən məbləğdən",
  fromNumber: "məbləğdən",
  fromSmth: "{value} məbləğdən",
  fulfillConditionsForWithdrawal: "Pul vəsaitlərinin çıxarılması üçün bütün şərtləri yerinə yetirin.",
  fund: "Uduş fondu",
  future: "Gələcək",
  game: "Oyun",
  gameDescTemplate: "{gameName} oyun avtomatı tanınmış {providerName} tərtibatçısından onlayn slotdur. {gameName} oyun avtomatında pulsuz oynayın və ya real pula oynamaq üçün qeydiyyatdan keçin",
  gameForMoneyOnlyForAuthUser: "Pul üçün oyun yalnız səlahiyyətli istifadəçilərə əlçatandır",
  gameInOtherTab: "Oyun digər pəncərədə açılıb",
  gameNotAvailableBonus: "Bonus şərtlərinə görə oyun əlçatan deyil",
  gameNotAvailableGeoRestriction: "Oyun sizin bölgənizdə mövcud deyil",
  gameNotFound: "Oyun tapılmadı",
  gameTitleTemplate: "{gameName} oyun avtomatı. {company} onlayn kazinosunda pulsuz oynamaq",
  gameUnavailable: "Oyuna daxil olmaq müvəqqəti olaraq mümkün deyil",
  game_categories: "Oyun kateqoriyaları",
  games: {
    tryOther: "Digər oyunları sınayın"
  },
  gamesNotFound: "Oyunlar tapılmadı",
  geoRestrictionDesc: "Üzr istəyirik, bu oyun sizin regionunuzda mövcud deyil.",
  geoRestrictionDescLine2: "Kataloqdan başqa oyun seçməyi təklif edirik",
  get: "Almaq",
  getBonus: "Bonus almaq",
  getBonusByPromoCode: "Promo kod ilə bonus almaq",
  getGainFromFreeSpins: "Frispinlərdən uduşların alınması",
  getNewCode: "Yeni kod əldə etmək",
  getSMS: "SMS kodunu almaq",
  go: "Keçmək",
  goBack: "Geriyə qayıtmaq",
  goToGame: "Oyuna keçmək",
  goToGames: "Oyunlara keçmək",
  goToHome: "Əsas səhifəyə qayıtmaq",
  goToOlimpCasinoAndPlayFavoriteGames: "Olymp kazino",
  goToVolet: "volet.com saytına gedin (advcash)",
  goToWallet: "Pul kisəsinə keçmək",
  goesNow: "İndi gəlir",
  gold: "Qızıl",
  guarantee: {
    five: "Öz müstəqil qərarı əsasında oyundan imtina. Əgər oynamaq istəyinin azaldılması məqsədilə Siz bizim kazinonun dəstək xidmətinə hesabınızı bloklamaq xahişi ilə müraciət edərsinizsə, Sizin xahişiniz yerinə yetiriləcək. Oyunçunun profilinin birdəfəlik ləğv edilməsi variantı mümkündür. Digər halda, oyunçunun arzusu ilə, o, müəyyən müddətin başa çatmasından sonra bərpa edilə bilər.",
    four: "Oyuna şəxsi girişi məhdudlaşdırmağı arzulayan oyunçular üçün növbəti variantlar işlənib hazırlanmışdır:",
    one: "Məsuliyyətli oyun",
    seven: "Girişin məhdudlaşdırılması. Əgər Siz özünüzü mərc oyunlarını təqdim edən və ya reklam edən müxtəlif vebsaytlardan qorumaq istəyirsinizsə, o zaman xüsusi proqram təminatından istifadə etməlisiniz. O, filtrləmə sistemləri yaradır və oyun asılılığına meylli olan istifadəçilərin internetdə təhlükəsiz şəkildə qalmasını təmin edir. Bundan əlavə, proqram təminatı uşaqların arzuolunmaz resurslara daxil olmasının qarşısını almaq üçün istifadə oluna bilər. Bu cür kompyuter proqramlarına nümunələr: Net Nanny (www.netnanny.com), CyberPatrol (www.cyberpatrol.com).",
    six: "İxtisaslaşdırılmış yardım. Oyun asılılığı inkişaf etdiyi təqdirdə, oyunçular ixtisaslaşmış mütəxəssislərin köməyinə müraciət edə bilərlər. Sizə kömək edə bilər: Gamblers Anonymous (www.gamblersanonymous.org.uk) – asılı oyunçulara yardım göstərən beynəlxalq anonim oyunçular cəmiyyəti; GamCare (www.gamcare.org.uk) – oyunçulara asılılıqdan yaxa qurtarmağa kömək edən ingilisdilli təşkilat; Gambling Therapy (www.gamblingtherapy.org) – geniş yayılmış xəstəliklə mübarizəyə ixtisaslı yardım göstərən, Böyük Britaniyada yerləşən təşkilat.",
    three: "Əgər Siz oyundan hər hansı asılılıq hiss edərsinizsə, o zaman ilk növbədə mərc oyunlarının Sizin üçün nə demək olduğunu müəyyən edin. Əgər oyun həyatın çətinliklərindən qaçmaq cəhdidirsə, əgər o, Sizin demək olar ki, bütün asudə vaxtınızı alırsa və işinizə mane olursa, bu, artıq ilk təhlükə siqnalıdır. Əgər Siz oyun üçün pul borc alırsınızsa və artıq öz gününüzü onsuz təsəvvür etmirsinizsə, bu həqiqətən onu göstərir ki, Sizə qətiyyətli dəyişikliklər etmək lazımdır.",
    two: "{titlePure} vebsaytda oynayan istifadəçilər qarşısında müəyyən məsuliyyət daşıyır. Kazinonun müdiriyyəti mümkün oyun asılılığının yaranmasının öhdəsindən gəlməkdə oyunçulara kömək etməyə hazırdır. Oyunun mahiyyəti müsbət emosiyalar bəxş etməkdən və gərginliyi azaltmaqdan ibarətdir. Əlbəttə, uğursuzluqlar da baş verə bilər, lakin bu, heç bir halda hər hansı maliyyə və ya sosial çətinliklərə səbəb olmamalıdır."
  },
  hasMinimalDeposit: "Minimum depozit qoyulmuşdur",
  haveActivatedFastbetMode: "Siz sürətli mərc rejimini aktivləşdirdiniz. Qaydalara baxmaq üçün klikləyin",
  haveNotEmailContactUs: "Əgər elektron poçtunuza məktub gəlməmişdirsə, zəhmət olmasa, \"Spam\" və \"Promoaksiyalar\" qovluqlarınızı yoxlayın və ya {0} ilə əlaqə saxlayın",
  haveNotPhoneContactUs: "Telefon nömrənizə SMS almamısınızsa, {0} ilə əlaqə saxlayın",
  here: "Burada",
  hiddenConditions: "Gizli şərtlər",
  hide: "Gizlətmək",
  hideBonusCondition: "Bonus şərtlərini gizlətmək",
  hideDetails: "Detalları gizlədin",
  history: "Tarixçə",
  historyBets: "Mərclərin tarixçəsi",
  historyPayments: "Ödənişlərin tarixçəsi",
  historyTransactions: "Əməliyyatlar tarixçəsi",
  hotGame: "İsti",
  hotGames: "Qaynar oyunlar",
  hotToBuyCryptoCurrency: "Kriptovalyutanı necə almaq olar?",
  howCanBuyCryptocurrency: "Kriptovalyutanı necə ala bilərəm?",
  howCreateCryptoWallet: "Kripto pulqabını necə yaratmaq olar?",
  howCreateWallet: "Cüzdanı necə yaratmaq olar?",
  howToCreateCryptoWallet: "Kripto pulqabını necə yaratmaq olar?",
  howToFindOutWalletNumber: "Pul kisəsinin nömrəsini necə bilmək olar?",
  howToInstallApp: "Mobil tətbiqi necə quraşdırmaq olar?",
  howToViewMyCryptoWalletInOlimp: "Как посмотреть мой крипто-кошелёк в Олимпе?",
  howTopUp: "Necə doldurmaq olar",
  howTransferCrypt: "Kriptovalyutanı necə köçürmək olar",
  howTransferCryptStep1: "Pulqabınıza və ya birjaya daxil olun",
  howTransferCryptStep2: "Seçilmiş {currency} pulu tapın",
  howTransferCryptStep3: "Pulqabımızın ünvanını daxil edin",
  howTransferCryptStep4: "Məbləği qeyd edin və göndərin",
  iPaid: "Doldurdum",
  idWasCopied: "Tranzaksiya id-ni kopyaladınız",
  inSettings: "parametrlərdə",
  information: "Məlumat",
  informationConfirmWithdraw: "Təhlükəsizlik və vəsaitin çıxarılması üçün bütün məlumatlarınızı təsdiqləyin. Elektron poçt ünvanınızı və ya telefon nömrənizi dəyişdirmək üçün Müştəri xidməti ilə əlaqə saxlayın",
  informationConfirmWithdrawSupport: "müştəri xidməti",
  informationForUpdateProfileData: "Əlaqə məlumatlarını yeniləmək üçün dəstək xidməti ilə əlaqə saxlamaq lazımdır",
  installApp: "Tətbiqi quraşdırmaq üçün {0}",
  installTrustWalletApp: "Установите приложение Trust Wallet",
  instant: "Tez",
  instantCash: "Cashback",
  instantCashback: "Ani Cashback",
  instantWithdrawal: "Ani çıxarma",
  instantly: "Dərhal",
  insufficientFundsAvailable: "Vəsait yetərli deyil. Mövcuddur:",
  invalidCryptoWallet: "Invalid wallet address",
  invalidDateFormat: "Yanlış tarix formatı",
  invalidDateInterval: "Seçilmiş interval yanlışdır",
  invalidStartDate: "Yanlış başlanğıc tarixi",
  iosWebAppInstruction: "iOS təlimatı",
  jackpot: "Cekpot",
  jackpotGame: "Cekpot ilə",
  january: "yanvar",
  july: "iyul",
  june: "iyun",
  kazakh: "Qazax",
  kycPolicy: "KYC siyasəti",
  latestGames: "Son oyunlar",
  leftCount: "{count} qaldı",
  leftDeposit: "{sum} artırmaq qalır",
  licenseCuracao: "Veb saytın məzmunu Perantia N.V.-yə (<a href='https://{domain}' target='_blank'> {domain}</a>) lisenziya sahibi kimi (Curacao lisenziya № 365/JAZ) məxsusdur və idarə olunur. Bütün hüquqlar  qanunla qorunur.",
  lineOn: "{date} tarixində xətt",
  linkIsReady: "Link hazırdır",
  liveCashBackDesc: "{company} yalnız VIP müştərilərimiz üçün əlçatan olan eksklüziv bonus təklif edir! Qısa təsvir - “LIVE Kazino” kateqoriyasındakı oyunlarda mərc edin və uduzulmuş mərclərin məbləğindən asılı olaraq hesabınıza Cashback qazanın!",
  liveCashback: "Canlı cashback",
  liveCashbackHistory: "Live cashback tarixçəsi",
  live_casino: "LİVE Casino",
  loading: "Yüklənir",
  loadingLanguage: "Dilin yüklənməsi",
  lobby: "Əsas səhifə",
  login: "İstifadəçi adı",
  loginCopied: "Logininiz kopyalandı",
  loginErr: "{name} istifadəçi adının tərkibində hərflər olmamalıdır!",
  loginTelegram: "Telegram vasitəsilə daxil olmaq",
  logoutFromSystem: "Sistemdən çıxış",
  lose: "Məğlubiyyət",
  losers: "Uduzan oyunçular",
  lottery: "Lotereya",
  mainPage: "Əsas səhifə",
  makeABet: "Mərc etmək",
  makeBet: "Mərc etmək",
  makeDeposit: "Depoziti daxil etmək",
  march: "mart",
  matchClosed: "Matç bağlıdır",
  matchEnded: "Matç başa çatdı",
  matchNotFound: "Matç tapılmadı",
  matchPlanned: "Matç planlaşdırılır",
  matches: "Matçlar",
  maxBet: "Maksimal mərc",
  maxForExpress: "Ekspress mərc üçün maksimum",
  maxLength: "Xananın maksimal uzunluğu {length}",
  maxOutput: "Minimal çıxarma məbləği",
  maxPay: "Maksimal ödəniş məbləği",
  maxSum: "Maks. məbləğ",
  maxValue: "Maksimal dəyər {value}",
  maxValueShort: "Maks: {value}",
  maxWithdrawSum: "Maksimal çıxarma məbləği",
  maximumPayment: "Maksimal ödəniş məbləği:",
  may: "may",
  messageSMS: "SMS kodu daxil edin",
  messages: "Mesajlar",
  middleName: "Ata adı",
  minBet: "Minimal mərc",
  minDepositForBonus: "Addımı tamamlamaq üçün ən azı {sum} məbləğində depozit qoyun",
  minLength: "Xananın minimal uzunluğu {length}",
  minLengthPassword: "Şifrənin minimal uzunluğu {min} simvol",
  minOutput: "Hesaba daxil etmə müddəti",
  minPay: "Minimal ödəniş məbləği",
  minSum: "Min.məbləğ",
  minValue: "Minimum dəyər {value}",
  minValueShort: "Min: {value}",
  minimalDeposit: "Minimum depozit",
  minimalLengthOfCode: "Minimum kod uzunluğu {num} simvol",
  minimalSum: "Minimum məbləğ",
  minimumPayment: "Minimal ödəniş məbləği:",
  minimumTransfer: "Hesaba köçürmənin minimal məbləği:",
  modal_telegram: "Kanalımızda aktiv bonuslar və aksiyalar, həftəlik hədiyyələr və bir çox digərlərini tapacaqsınız və botla sayta girişinizi heç vaxt itirməyəcəksiniz!",
  more: "Daha çox",
  moveToBonus: "Bonusa keçin",
  moveToMessages: "Mesajlara keçin",
  myBalances: "Mənim balanslarım",
  myBonuses: "Mənim bonuslarım",
  name: "Ad",
  namePerson: "Ad",
  nameTheCheckout: "Pulqabının ünvanını kassirə təqdim edin",
  navGamesCat: {
    aviator: "Aviator",
    aviatrix: "Aviatrix",
    betGames: "BetGames",
    fantasy: "Fantasy",
    fast: "Tez",
    jetx: "JetX",
    line: "Xətt",
    live: "Canlı",
    liveGames: "LiveGames37",
    lottery: "Lotereya",
    online: "Live Kazino",
    slot: "Slotlar",
    sportGames: "İdman oyunları",
    table: "Masa oyunları",
    turboGames: "Turbo oyunlar",
    vSport: "V-Sport",
    virtualGames: "Virtual",
    worldcup: "Dünya Kuboku-2022"
  },
  navLinks: {
    bonuses: "Bonuslar",
    home: "Ana səhifə",
    homeCasino: "Kazino",
    posts: "Mesaj",
    profile: "Profil",
    promo: "Aksiyalar",
    sport: "İdman",
    tournament: "Turnirlər"
  },
  needConfirmProfileInformation: "Bonusu aktivləşdirmək üçün profilinizdə məlumatlarınızı təsdiqləyin",
  needDeposit: "Depozit tələb olunur",
  needSettingsSecurity: "Təhlükəsizlik parametrlərindən tənzimləmək lazımdır",
  needToExecuteConditions: "Şərtlər yerinə yetirilməlidir",
  never: "Heç vaxt",
  "new": "Yeni",
  new2: "Yenilər",
  newBonusAvailable: "Siz yeni bonus qazana bilərsiniz",
  newGame: "Yeni",
  newMessage: "Yeni mesaj",
  newMessages: "Yeni mesajlar",
  newOne: "Yeni",
  newVersionReloadPage: "Saytın versiyası yenilənib, düzgün işləmə üçün səhifəni yeniləyin",
  newYearPromocodes2025: {
    NY25DAY1: "Santa's Gift oyununda 50 FS",
    NY25DAY10: "İdman üçün fribet!",
    NY25DAY11: "Santa's Great Gifts oyununda 50 FS",
    NY25DAY12: "Royal Xmass 2 oyununda 75 FS",
    NY25DAY13: "Depozitə 75% və 75 FS hədiyyə!",
    NY25DAY14: "Santa's Xmas Rush oyununda 100 FS",
    NY25DAY2: "İdman üçün fribet!",
    NY25DAY3: "Depozitə 50% və 50 FS hədiyyə!",
    NY25DAY4: "Buffalo Power: Christmas oyununda 75 FS",
    NY25DAY5: "Depozitə 75% və 75 FS hədiyyə!",
    NY25DAY6: "Royal Xmass oyununda 75 FS",
    NY25DAY7: "Depozitə 100% və 100 FS hədiyyə!",
    NY25DAY8: "Sugar Rush Xmas oyununda 100 FS",
    NY25DAY9: "Depozitə 50% və 50 FS hədiyyə!"
  },
  next: "Sonra",
  nextGames: "Daha çox göstərmək",
  no: "Xeyr",
  noAccount: "Hesab yoxdur",
  noBetsInHistory: "Tarixçənizdə heç bir təklif yoxdur",
  noConnectionTryAlready: "İnternet bağlantısı yoxdur. İnternetə qoşulun və yenidən cəhd edin.",
  noDeposit: "Depozit yoxdur",
  noFavoritesYet: "Seçilmişlərdə hələ heç nə yoxdur",
  noMatchSelected: "Heç bir matç seçilməyib və ya Line-da heç bir hadisə yoxdur!",
  noResults: {
    bets: "Sizin mərclər burada əks olunacaq",
    bonuses: "Mümkün bonuslar burada əks olunacaq",
    competitions: {
      active: "Cari turnirlər burada əks olunacaq",
      all: "Cari turnirlər burada əks olunacaq",
      ended: "Keçmiş turnirlər burada əks olunacaq",
      future: "Gələcək turnirlər burada əks olunacaq"
    },
    gamesNotFound: "Oyun tapılmadı",
    gamesSearch: "Sizin sorğunuz üzrə oyunlar tapılmadı, başqa sorğu daxil etməyə cəhd edin",
    messages: "Sizin mesajlarınız burada əks olunacaq",
    payin: "Hesabın artırılması üçün əlçatan üsullarınız yoxdur",
    payout: "Əlçatan vəsait çıxarışı üsullarınız yoxdur",
    simple: "Nəticə yoxdur",
    transactions: "Sizin əməliyyatlar burada əks olunacaq",
    withdraw: "Sizin vəsaitlərin çıxarılmasına dair tələbnamələriniz burada əks olunacaq"
  },
  noSelectionsForBetting: "Mərc üçün nəticələr seçilməyib",
  nomination: "Turnirin nominasiyası",
  nonBonusGame: "Oyun bonus proqramında iştirak etmir. Hesabınızı əsas hesaba keçirəcəyik.",
  nonBonusGameBetsNotCountInVager: "Oyun bonus proqramında iştirak etmir. Məcrlər bonusun veycerində nəzərə alınmır",
  nonBonusGameWithoutBalance: "Oyun bonus proqramında iştirak etmir. Oynamaq üçün əsas hesabınızı artırın.",
  notBonuses: "Hazırda qazanıla bilən bonuslar yoxdur",
  notCompetition: "Hazırda cari turnirlər yoxdur",
  notConfirmed: "Təsdiqlənməyib",
  notDeposit: "Əmanət daxil edilməyib",
  notEnoughEventsForExpress: "Ekspress üçün kifayət qədər tədbirlər yoxdur",
  notEnoughEventsForSystem: "Sistem üçün kifayət qədər tədbirlər yoxdur",
  notEnoughMoneyToWithdraw: "Vəsait çıxarışı üçün kifayət qədər vəsait yoxdur",
  notEnoughVventsForSystem: "Sistem üçün kifayət qədər tədbirlər yoxdur",
  notInterested: "Maraqlı deyil",
  notLogin: "{name} istifadəçi adını daxil edin!",
  notNow: "İndi yox",
  notPass: "Parolu daxil edin!",
  notSufficient: "kifayət deyil",
  notValidValue: "Yanlış dəyər",
  notification: "Bildiriş",
  november: "noyabr",
  nowInLine: "İndi xətdə",
  nowPlayed: "İndi udulub qaytarılmışdır",
  numberErr: "Zəhmət olmasa qeydiyyat zamanı göstərilən nömrəni yoxlayın",
  numberOfWallet: "Pul kisəsinin nömrəsi",
  october: "oktyabr",
  onAccountBK: "BK hesabında:",
  oneClick: "Bir klikdə bankı çoxalt",
  online: "Onlayn",
  onlyForYou: "Yalnız Sizin üçün",
  open: "Açmaq",
  openAppTrustWallet: "Откройте приложение и вам будет доступно две функции - зарегистрировать новый кошелёк или восстановить имеющийся. Нажмите нажать на «Создать новый кошелек»",
  openEmail: "Email açmaq",
  openGameNewTab: "Oyunu açmaq üçün düyməni basın",
  openSafari: "Safari-də açın",
  openSafariIfAnotherBrowser: "Başqa bir brauzerdəsinizsə, bu səhifəni Safari brauzerində açın",
  openTelegramBot: "Telegram botunu açın",
  operations: "Əməliyyatların tarixçəsi",
  orders: "Sifarişlər",
  ordinary: "Tək mərc",
  ordinarySeries: "Tək mərclər seriyası",
  other: "Digər",
  otherSections: "Digər bölmələr",
  ourSocialMedia: "Bizim sosial şəbəkələr",
  ourSocialMediaShort: "Bizim sosial şəbəkələr",
  out: "Çıxmaq",
  output: "Vəsaitlərin çıxarılması",
  outputModalTitle: "Vəsait çıxarışının təsdiqi",
  outputSuccess: "Vəsaitlərin çıxarılması uğurla başa çatdırıldı!",
  overallCoef: "Ümumi əmsal",
  page: "Səhifə",
  pageErr: "Səhifə tapılmadı",
  pageErrDesc: "Səhifə silinib, yaxud ünvan düzgün daxil edilməyib",
  pageNotFound: "Səhifə tapılmadı!",
  pageNotFoundDesc: "Səhifə silinib, yaxud ünvan düzgün daxil edilməyib",
  participant: "İştirakçı",
  participate: "Participate",
  passErr: "Parolu unutmusunuz?",
  passMessage: "Parol rəqəmlərdən, böyük və kiçik hərflərdən ibarət olmalıdır",
  passportIndex: "Pasport nömrəsi / ID",
  password: "Parol",
  passwordChanged: "Şifrə dəyişdirilib",
  passwordErr: "Qeydiyyat",
  passwordNew: "Yeni şifrə",
  passwordSuccess: "Parol uğurla bərpa edildi",
  passwordTheSame: "Şifrə cari şifrədən fərqli olmalıdır",
  past: "Keçmiş",
  pay: "Ödəniş",
  payBonusErr: "Bonusun satın alınması üçün ___ -dən az olmayan məbləğdə depozit daxil etmək qalıb",
  payMethod: "Hesabı artırma üsulu",
  payMethods: "Hesabı artırma üsulları",
  paymentMethod: "Ödəniş üsulu:",
  paymentSuccess: "Vəsaitlərin köçürülməsi uğurla başa çatdırıldı!",
  payoutPayTrxsExistsText: "Vəsait çıxarmaq üçün ən azı bir depozit qoymalısınız",
  payoutThresholdStatusText: "Vəsait çıxarmaq üçün {count} mərc etməlisiniz",
  period: "Dövr",
  personInformationIsApprove: "Məlumatlar qəbul edilir, hesab qorunur",
  personalArea: "Şəxsi kabinet",
  personalData: "Şəxsi məlumatlar",
  personalDataApproved: "Şəxsi məlumatlar təsdiqləndi",
  personalDataIsFilled: "Şəxsi məlumatlar doldurulub",
  personalDataSuccessfullyEdited: "Şəxsi məlumatlarınız uğurla dəyişdirildi",
  phone: "Telefon",
  phoneErr: "Telefon nömrəsinin tərkibində hərflər ola bilməz!",
  phoneNum: "Telefon nömrəsi",
  phoneSuccessfullyApproved: "Telefon nömrəsi uğurla təsdiqləndi",
  pickUpBonus: "Bonusu götürmək",
  place: "Yer",
  placeAQuickBet: "Sürətli mərc edilsin?",
  places: "Mükafat alan yerlər",
  placesCount: "{count} yer",
  placesPrice: "Pul mükafatı",
  play: "Oynamaq",
  playAviator: "Aviator oyunu oynamaq",
  playBonus: "\"Təbrik edirik, siz bonusu udub qaytardınız! Vəsaitlərin çıxarılması balansın ən azı {count} məbləği qədər artırılmasından sonra mümkün olacaq. Bonus başa çatdırılıb. Oyunu davam etdirmək üçün hesabı ən azı {count} məbləği qədər artırın\"",
  playBonusEnded: "Bonus bitdi. Oyunun davam etməsi üçün hesabınıza {count} məbləğində əmanət qoyun",
  playForMoney: "Pul üçün oynamaq",
  playGamesInCategoryes: "Kateqoriyadan oyunlar oynamaq",
  playWithoutBonus: "Bonussuz oynamaq",
  playingInAppMoreConvenient: "Tətbiqdə oynamaq daha rahatdır",
  pleaseConfirmAgreementToTheTerms: "Xahiş edirik, şərtlərlə razılaşdığınızı təsdiq edin",
  pleaseConfirmInformation: "Xahiş edirik, məlumatı təsdiq edin",
  pleaseSelectOutcome: "Zəhmət olmasa nəticəni seçin",
  pleaseUseNumberOfCharacters: "{num} simvol istifadə edin",
  point: "Xallar",
  points: "xal yoxdur | {n} xal | {n} xal | {n} xal",
  postSMS: "SMS kodunu göndərmək",
  posts: "Mesaj",
  potentialWin: "Potensial uduşlar",
  ppenFullBetHistory: "Tam mərc tarixçəsini açın",
  preparedForRemoval: "Çıxarılmaya hazırlandı (emal edildi)",
  preview: "İlkin izləmə",
  prize: "Mükafat",
  prizes: "Qaliblərin mükafatları",
  proceed: "Davam etmək",
  processDeposit: "Hesabın artırılmasının emalı",
  processDepositDescription: "Ödəniş göndərilib və ödəniş sistemi tərəfindən emal edilir. Vəsaitlərin kreditləşdirilməsi müddəti bir neçə dəqiqədən bir neçə günə qədər ola bilər",
  processWagerFromBonusBalance: "Bonus balansından mərcin yerinə yetirilməsi",
  processWagerFromDeposit: "Depozit məbləğinə əsasən mərcin yerinə yetirilməsi",
  processed: "Emal olunur",
  processing: "Emal olunur",
  promo: "Aksiyalar",
  promoCodeActivationSuccess: "Promod uğurla aktivləşdirilib",
  promoGames: "Bonus oyunları",
  promoMaxBetExceeded: "Mərc etmək üçün istifadə ediləcək maksimum mərc məbləği {bet} {currency}",
  promoNotFound: "Qüvvədə olan aksiyalar yoxdur",
  promocode: {
    activate: "Promokodu aktivləşdirmək",
    placeholder: "Promokod",
    title: "Promokodun aktivləşdirilməsi"
  },
  promocodes: {
    NY25DAY1: "Santa's Gift oyununda 50 FS",
    NY25DAY10: "Santa's Great Gifts oyununda 50 FS",
    NY25DAY11: "İdman üçün fribet!",
    NY25DAY12: "Royal Xmass 2 oyununda 75 FS",
    NY25DAY13: "Depozitə 75% və 75 FS hədiyyə!",
    NY25DAY14: "Santa's Xmas Rush oyununda 100 FS",
    NY25DAY2: "Depozitə 50% və 50 FS hədiyyə!",
    NY25DAY3: "İdman üçün fribet!",
    NY25DAY4: "Buffalo Power: Christmas oyununda 75 FS",
    NY25DAY5: "Depozitə 75% və 75 FS hədiyyə!",
    NY25DAY6: "Royal Xmass oyununda 75 FS",
    NY25DAY7: "Depozitə 100% və 100 FS hədiyyə!",
    NY25DAY8: "Sugar Rush Xmas oyununda 100 FS",
    NY25DAY9: "Depozitə 50% və 50 FS hədiyyə!",
    NYDAY1: "Hell Hot 100 oyununda 50 FS",
    NYDAY10: "Santa's Great Gifts oyununda 50 FS",
    NYDAY11: "İdman üçün fribet",
    NYDAY12: "Aviator üçün fribetlər",
    NYDAY13: "Depozitə 75% və 75 FS hədiyyə!",
    NYDAY14: "Sugar Rush Xmas oyununda 100 FS",
    NYDAY2: "Depozitə 50% və 50 FS hədiyyə!",
    NYDAY3: "İdman üçün fribet!",
    NYDAY4: "JetX üçün fribetlər",
    NYDAY5: "Depozitə 75% və 75 FS hədiyyə!",
    NYDAY6: "Twin fruits of Santa oyununda 75 FS",
    NYDAY7: "Depozitə 100% və 100 FS hədiyyə!",
    NYDAY8: "Sugar Rush Xmas oyununda 100 FS",
    NYDAY9: "Depozitə 50% və 50 FS hədiyyə!"
  },
  promocodes2025: {
    NY25DAY1: "Santa's Gift oyununda 50 FS",
    NY25DAY10: "İdman üçün fribet!",
    NY25DAY11: "Santa's Great Gifts oyununda 50 FS",
    NY25DAY12: "Royal Xmass 2 oyununda 75 FS",
    NY25DAY13: "Depozitə 75% və 75 FS hədiyyə!",
    NY25DAY14: "Santa's Xmas Rush oyununda 100 FS",
    NY25DAY2: "İdman üçün fribet!",
    NY25DAY3: "Depozitə 50% və 50 FS hədiyyə!",
    NY25DAY4: "Buffalo Power: Christmas oyununda 75 FS",
    NY25DAY5: "Depozitə 75% və 75 FS hədiyyə!",
    NY25DAY6: "Royal Xmass oyununda 75 FS",
    NY25DAY7: "Depozitə 100% və 100 FS hədiyyə!",
    NY25DAY8: "Sugar Rush Xmas oyununda 100 FS",
    NY25DAY9: "Depozitə 50% və 50 FS hədiyyə!"
  },
  promotionNotFound: "Belə aksiya yoxdur",
  protectYouData: "Şəxsi məlumatlarınızı və vəsaitlərinizi qoruyun",
  protection: "Məxfilik siyasəti",
  protectionSettingsMessage: "Akkauntunuzun təhlükəsizliyinin sazlanması vəsaitlərinizi qorumaq və onları təhlükəsiz şəkildə çıxarmaq üçün lazımdır",
  providers: "Provayderlər",
  purchaseCryptocurrency: "Покупка криптовалюты",
  putSend: "Kodu almaq",
  queue: "Növbədədir",
  reSendCode: "Kodu təkrar göndərmək",
  read: "Oxunub",
  readyForWithdrawOnCashier: "Kassada ödəniş üçün hazırdır",
  receiveWithdrawalConfirmation: "Elektron poçt/Telegram vasitəsilə vəsait çıxarışının təsdiqini alın",
  recomend: "Biz tövsiyə edirik",
  recovery: "Parolun bərpa edilməsi",
  recoveryEmailDesc: "Hesabınıza daxil olmaq üçün qeydiyyat zamanı göstərdiyiniz elektron poçtu daxil edin",
  recoveryPassword: "Şifrəni bərpa etmək",
  recoveryPhoneDesc: "İstifadəçi hesabına giriş imkanı qazanmaq üçün qeydiyyat zamanı göstərdiyiniz telefon nömrəsini daxil edin",
  recoveryWord: "Bərpa",
  refill: "Hesabın artırılması",
  refresh: "Yeniləmək",
  refreshPage: "Səhifəni yeniləyin",
  refund: "Qaytarma",
  refundPolicy: "Vəsaitin geri qaytarılması siyasəti",
  refundWithdrawal: "Vəsait çıxarışı ləğv edilsin",
  refundWithdrawalModalDesc: "Vəsait çıxarışınızı ləğv etmək istədiyinizə əminsiniz? Ləğv edilərsə, vəsait əsas balansa qaytarılacaq.",
  refundWithdrawalNoun: "Vəsait çıxarışının ləğv edilməsi",
  reg: "Qeydiyyat",
  register: "Qeydiyyatdan keçmək",
  registrationBonus: "Qeydiyyata görə bonus",
  rejected: "Rədd edildi",
  remainingPlay: "Udub qaytarmaq qalıb",
  repeatPassword: "Şifrəni təkrarlayın",
  repeatTopUpDesc: "Ödəniş alınmadı? Yenidən cəhd edək?",
  replenishment: "Hesabın artırılması",
  requirement: "Tələb",
  requisiteDesc: "Hesabınızı artırmaq üçün {sum} hesabınıza köçürün. Hesabın uğurla artırılması üçün məbləğ göstərilənə tam uyğun olmalıdır.",
  resend: "Təkrarən göndərmək",
  resendCodeCanAfter: "Kodu {0} vasitəsilə yenidən göndərə bilərsiniz",
  reset: "İlkin vəziyyətə qaytarmaq",
  resetFilters: "Filtri sıfırlamaq",
  resetIt: "sıfırlamaq",
  responsibleGame: "Məsuliyyətli oyun",
  result: "Yekun",
  results: "Nəticələr",
  resultsSearch: "Axtarış nəticələri",
  "return": "Geri qaytarma",
  rollback: "Kənara çəkilmə",
  rules: "Qaydalar və şərtlər",
  rulesDescription: "Qaydalar",
  rulesShort: "Qaydalar",
  rulesTournament: "Turnirin şərtləri və qaydaları",
  russian: "Rus",
  sales: "Satıldı",
  save: "Yadda saxla",
  schedule: "Cədvəl",
  scores: "xallar",
  search: "Axtarış",
  searchProviders: "Provayderin adı",
  seats: "Yerlər",
  secretAnswer: "Təhlükəsizlik sualına cavab",
  secretQuestion: "Təhlükəsizlik sualı",
  security: {
    five: "Əgər sizin məlumatın qorunması haqqında suallarınız qalıbsa, zəhmət olmasa onlayn dəstək xidmətinə müraciət edin və ya {support} ünvanına məktub göndərin. Biz sizə kömək etməyə şad olarıq.",
    one: "Biznesin dünya standartlarına uyğun həyata keçirilməsi məsələsində öz qətiyyətli mövqeyimizi göstərmək üçün biz məlumatın qorunması haqqında bu müddəanı paylaşırıq.",
    seven: "Məlumatın qorunması",
    six: "Vebsaytdakı xidmətlər və məlumatlar Podgorica, Cetinjski put bb, reg. no. 5-0685623/1 ünvanında yerləşən \"Euromirbet d.o.o.\" şirkəti tərəfindən təqdim edilib. Ödəniş Kartları Sənayesinin Təhlükəsizlik Standartları Şurasının tövsiyələrinə uyğun olaraq, alıcının məlumatlarının qorunması üçün TLS 1.2 nəqletmə səviyyəsində və tətbiq səviyyəsində 256 bit uzunluğunda açara malik olan AES alqoritmi vasitəsilə şifrləmə istifadə olunur.",
    three: "{titlePure} anti-spam siyasətini rəhbər tutur. Bizim oyunçulara göndərilən bütün məktublar onların oyun hesablarına aiddir, habelə həmin məktublarda oyunçuların kazinoda yeni imkanları haqqında məlumat və ən vacib reklam materialları ola bilər. Reklam göndərmələrinin müntəzəmliyi fərqli ola bilər və gündə 3 məktuba qədər çata bilər. Oyunçular göndərmələrdən imtina etmək hüququnu özündə saxlayır - bu halda onlayn dəstək xidməti ilə əlaqə qurmaq və ya məktubun aşağısındakı müvafiq istinada basmaqla, istənilən vaxtda abunəlikdən çıxmaq lazımdır. Sizin uduşlarınız və sizə edilən ödənişlər haqqında məlumat da tam məxfidir və təhlükəsiz mühitdə saxlanılır.",
    two: "Biz inanırıq ki, düzgün biznes münasibətləri yalnız dürüstlük və etimad üzərində qurulur. Ona görə də sizin məlumatınızın məxfiliyi bizim üçün həddindən çox vacibdir. Siz əməliyyatlarınızın qorunmasının təmin edilməsi üzrə bütün tədbirlərin bizim tərəfimizdən görüldüyünü bilərək, oyundan həzz ala bilərsiniz. Sizin adınız, poçt ünvanınız, e-poçt ünvanınız, telefon nömrəniz, doğum tarixiniz, cinsiniz, İP ünvanınız və digər məlumatınız özəldir və məxfidir və üçüncü şəxslərə ötürülə, satıla və paylanıla bilməz."
  },
  securityAnswer: "Məxfi cavab",
  securityQuestion: "Məxfi sual",
  securitySetting: "Təhlükəsizliyin sazlanması",
  selectAll: "Hamısını seçin",
  selectApproveMethod: "Çıxarışı təsdiqləmə üsulunu seçin",
  selectCountryToReceive: "Bölgədəki cari təklifləri və şərtləri almaq üçün ölkə seçin",
  selectPaymentCurrencyAndClickTopUpAccount: "Hesablama valyutasını seçin və \"Balansın artırılması\" düyməsini sıxın",
  selectProviders: "Seçilmiş provayderlər üzrə bütün oyunlar",
  selectQuestion: "Əvvəlcə sualı seçin",
  selectVariable: "Uyğun variantı seçin",
  sellBet: "Mərci satmaq",
  send: "Göndərmək",
  sendCode: "Kodu göndərmək",
  sendCodeError: "Kodu daxil etmək mümkün olmursa, dəstək xidmətilə",
  sendCodeErrorSupport: "əlaqə saxlayın",
  sendCodeRepeat: "Kodu yenidən göndərin",
  sendCodeSuccess: "Kod telefona göndərildi",
  sendCodeSuccessEmail: "Kod poçta göndərildi",
  sendConfirmationEmail: "Təsdiq email məktubu göndərdik",
  sendConfirmationPhone: "{phone} nömrəsinə kod olan SMS göndərdik",
  sendDocuments: "Sənədləri göndərmək",
  sendSMS: "SMS kodunu göndərmək",
  sendedCodeToEmail: "Kod poçta göndərildi <br> {email}",
  sendedCodeToPhone: "Kod telefona göndərildi <br> {phone}",
  september: "sentyabr",
  serverErrorTryAgain: "Server xətası, bir daha sınayın",
  serverErrorTryRefresh: "Server xətası, yeniləməyə çalışın",
  settlementCurrency: "Hesablaşma valyutası",
  sgtv_bonus: {
    block_one_li_four: "10 fribet alın",
    block_one_li_one: "Bonusu almaq üçünbalansınızda {sum}{currency} olmalıdır.",
    block_one_li_three: "Menyuda bonusu aktivləşdirin.",
    block_one_li_two: "Bonusu aktivləşdirmək üçün SGTV provayderinin istənilən oyununa keçin.",
    block_one_title: "Bonusunuzu necə əldə etmək olar:",
    block_two_li_eight: "Bonusa x20 mərc tələbi tətbiq edilir. Minimum mərc əmsalı 1.5-dir.",
    block_two_li_eleven: "Olymp istənilən vaxt təklifin şərtlərini dəyişdirmək və ya ləğv etmək, həmçinin izahat vermədən istənilən oyunçudan imtina etmək hüququnu özündə saxlayır.",
    block_two_li_five: "Yeni oyunçu Sport Games bölməsinə daxil olarkən nominal dəyəri {sum} {currency} təşkil edən 10 fribet qazanır.",
    block_two_li_four: "Bonus dərhal əlavə olunur. Seçilmiş bonus əlavə olunmayıbsa, oyuna başlamazdan əvvəl Müştəri xidməti ilə əlaqə saxlamalısınız. Oyuna bonussuz başlasanız, bonus verilməyəcək.",
    block_two_li_nine: "Depozitsiz fribetlərdən və depozitsiz bonuslardan uduşların çıxarıla bilən maksimum məbləği {sum} {currency} təşkil edir.",
    block_two_li_one: "İstifadəçinin yalnız bir bonus hüququ var.",
    block_two_li_seven: "Bonus aktivləşdirildikdən sonra 3 gün ərzində mövcuddur.",
    block_two_li_six: "Fribetlərdən “Nərd”, “Boks”, “Darts”, “Bric”, “Bullitlər” oyunlarında istifadə etmək olar.",
    block_two_li_ten: "Fribetlər 1.3-dən 5-ə qədər olan əmsallara mərc etmək üçün istifadə edilə bilər.",
    block_two_li_three: "Bonus əldə etmək üçün hesabı {sum} {currency} və daha yuxarı məbləğdə artırmalısınız.",
    block_two_li_two: "Bonuslar (fribetlər) SportgamesTV-də heç vaxt mərc etməmiş oyunçulara verilir.",
    block_two_title: "Şərtlər və müddəalar:",
    important_text: "Vacibdir! Əgər siz bonusu aktivləşdirmədən oyuna başlasanız, o zaman fribetlər sonradan əlavə olunmayacaq.",
    title: "SportGamesTV-də yeni oyunçular üçün fribetlər! “Nərd”, “Boks”, “Darts”, “Bric”, “Bullitlər” oyunlarında 10 fribet əldə edin."
  },
  shallWePlay: "Oynayaq?",
  shortDescription: "Qısa təsvir",
  show: "Göstərmək",
  showAll: "Hamısını göstərmək",
  showBets: "Mərcləri göstərmək",
  showCodeOnlyForOperator: "Təsdiq kodunu kassirdən savayı heç kimə bildirməyin",
  showGame: "Oyunu göstərmək",
  showGames: "Oyunları göstərmək",
  showMatchesStarting: "Başlayan matçları göstərmək:",
  showMoreGames: "Daha çox oyun göstərmək",
  showTerms: "Şərtləri göstərmək",
  showTransactions: "Əməliyyatları göstərmək",
  signUp: "Qeydiyyatdan keçmək",
  signUpAndVerifyVolet: "15 dəqiqə çəkən qeydiyyatdan keçin və verifikasiyadan keçin",
  signin: "Daxil olmaq",
  silver: "Gümüş",
  slots: "Slotlar",
  smallDescription: "Turnirin qısa təsviri",
  smsCode: "SMS kodunu almaq",
  smsInfo: "Sizin nömrənizə SMS kod göndəriləcək",
  smsSendingDesc: "Bizim nömrəyə göndərdiyimiz kodu daxil edin",
  smsVer: "Ödənişlərin SMS vasitəsilə yoxlanıb təsdiqlənməsi",
  smsVerDisabled: "Ödənişlərin SMS vasitəsilə yoxlanıb təsdiqlənməsi funksiyası söndürülüb",
  smsVerEnabled: "Ödənişlərin SMS vasitəsilə yoxlanıb təsdiqlənməsi funksiyası yandırılıb",
  socialAuthError: "Sosial şəbəkə vasitəsilə avtorizasiya zamanı xəta",
  soonStarted: "Tezliklə başlayacaq",
  sort: "Sıralamaq",
  spaceNotAvailableForField: "Bu xanada məsafələr yolverilməzdir",
  specifyNumberYourPersonalCryptoWallet: "В поле укажите номер вашего личного крипто-кошелька на сайте Olimp.com.",
  spinsBeforeCrediting: "Vəsait hesaba daxil edilənə qədər spinlərin sayı:",
  sportErrorText: "Hazırda “İdman” bölməsini yeniləyirik, lakin tezliklə hər şeyi bərpa edəcəyik.",
  sports: "İdman",
  stakeHasBeenSuccessfully: "Sizin mərciniz uğurla qəbul edildi!",
  startSecuritySetup: "Təhlükəsizliyin sazlanmasını keçmək",
  stateOfAnAccount: "Hesabın vəziyyəti",
  status: "Status",
  statusAcc: "Hesabın statusu:",
  statusOfTransaction: "Əməliyyatın statusu",
  statusSuccess: "Təsdiq edilib",
  statuses: {
    calculationInProgress: "Hesablama gedir",
    inProcess: "Proses gedir",
    notPayed: "Ödənilməyib",
    payed: "Ödənilib"
  },
  sub_telegram: "Teleqrama abunə olun",
  success: "Əməliyyat uğurla keçdi",
  successEnterTournament: "Great, you're in the tournament!\n",
  successPromoCode: "Promod uğurla aktivləşdirilib",
  sufficient: "Yetərli",
  sum: "Məbləğ",
  sumBet: "Mərc məbləği",
  sumMoreThanBalance: "Məbləğ balansdakı məbləğdən çoxdur",
  sumWithdraw: "Ödəniş məbləği",
  support: "Dəstək",
  supportContact: "Dəstək xidmətin müraciət etmək",
  surname: "Soyad",
  suspended: "Dayandırılıb",
  system: "Sistem",
  table: "Masa oyunları",
  tapOnHome: "\"Evə ekranına\" bəndini sıxı, sonra isə \"Hazırdır\" sıxın",
  tapOnShareIcon: "Ekranın alt hissəsindəki menyuda \"Bölüşmək\" ikonkasını sıxın. Dialoq pəncərəsi açılacaq",
  term: "Hesaba daxil etmə müddəti",
  termEnrollment: "Hesaba daxil etmə müddəti:",
  termFulfillment: "Şərtlərin yerinə yetirilməsinə ayrılan vaxt:",
  termsAndConditions: "Qaydalar və şərtlər",
  termsAndConditionsList: "Şərtlər və müddəalar:",
  timeFulfill: "Şərtlərin yerinə yetirilməsi üçün vaxt:",
  timeRemaining: {
    txt: "Kodu bir daha almaq üçün {seconds} saniyə qalıb",
    txtPay: "{seconds} saniyə sonra yeni kodu ala biləcəksiniz"
  },
  timeToActivateBonus: "Bonusun aktivləşdirilməsinə ayrılan vaxt",
  timer: {
    oneLetter: {
      day: "d",
      hour: "h",
      minute: "m",
      second: "ilə"
    },
    "short": {
      day: "gün",
      hour: "saat",
      minute: "dəqiqə",
      second: "saniyə"
    }
  },
  tip: "Bəxşiş",
  titles: {
    cashback: "Cashback",
    dropsWins: "Uduzmalar və uduşlar",
    err404: "Axtarılan səhifə mövcud deyil",
    fraud: "Fırıldaqçılıqdan mühafizə",
    gameGroups: {
      "GamesByGroup\/slot": "Onlayn slotlar – pulla oyun avtomatları oynamaq, qeydiyyatsız, pulsuz"
    },
    home: "{titlePure}",
    profile: "Profil",
    protection: "Məlumatın qorunması",
    responsibleGame: "Məsuliyyətli oyun",
    rules: "Qaydalar və şərtlər",
    tournaments: "Turnirlər",
    work: "Texniki işlər aparılır"
  },
  to: "{date} tarixinədək",
  toFindOutWalletAddressOfCoin: "Чтобы узнать адрес кошелька какой-либо монеты, на основном экране нажмите на монету которую хотите получить, далее отобразится страница монеты с историей транзакций",
  toPromoStart: "Aksiyanın başlamasına qədər",
  toSupport: "müştəri xidmətinə",
  topLines: "Top xəttlər",
  topUp: "Hesabı artırmaq",
  topUpWith: "vasitəsilə hesabı artırmaq",
  topupYourBalance: "Pulla oynamaq üçün balansınızı artırın",
  total: "Cəmi",
  tournament: "Turnir",
  tournamentCryptoReminderText: "Для получения выигрыша не забудьте указать криптокошелёк Doge в личном кабинете ",
  tournamentDescription: "Turnirin təsviri",
  tournamentEnded: "Turnir bitib",
  tournamentGame: "Oyun turnirdə iştirak edir",
  tournamentGames: "Turnirin oyunları",
  tournamentMounth: {
    "01": "Yanvar",
    "02": "Fevral",
    "03": "Mart",
    "04": "Aprel",
    "05": "May",
    "06": "İyun",
    "07": "İyul",
    "08": "Avqust",
    "09": "Sentyabr",
    "10": "Oktyabr",
    "11": "Noyabr",
    "12": "Dekabr"
  },
  tournaments: "Turnirlər",
  transactionCopied: "Tranzaksiya id-ni kopyaladınız",
  transactionSuccess: "Əməliyyat uğurla başa çatdırıldı",
  transactionsIsNotExist: "Hələ heç bir əməliyyatınız olmayıb",
  transactionsNotFound: "Seçilmiş filtrlər üzrə heç bir əməliyyat tapılmadı. Filtr parametrlərini redaktə etməyə cəhd edin və ya {0}",
  transfer: "Köçürmək",
  transferAccount: "Hesaba köçürmə",
  transferAmount: "Köçürmənin məbləğini daxil edin",
  transferAmount2: "Köçürmə məbləğini daxil edin",
  transferSuccessfully: "Vəsaitlərin köçürülməsi uğurla başa çatdırıldı!",
  transferTheMoneyAndWait: "Vəsaiti kassirə təqdim edin və hesabın artırılmasını gözləyin",
  transitionDate: "Əməliyyat tarixi",
  transitionStatus: "Əməliyyatın statusu",
  transitionType: "Дата транзакции",
  turnOff: "Söndürün",
  turnOn: "Yandırın",
  turnOnState: "Daxildir",
  turnover: "Dövriyyə",
  twoFactorAuth: "İki faktorlu identifikasiya",
  typeOfTransaction: "Əməliyyat növü",
  uncalculated: "Hesablanmamış",
  underCoinBalanceClickGetButton: "Под балансом монеты нажимаем кнопку «Получить». Далее необходимо скопировать адрес при помощи кнопки или использовать штрихкод для сканирования ",
  unexpectedErrorWriteToSupport: "Gözlənilməz xəta baş verdi, lakin tezliklə hər şeyi düzəldəcəyik.",
  unexpected_error_try_again: "Gözlənilməz xəta, bir daha sınayın",
  unhandledErrorTryToRefreshPage: "Gözlənilməz xəta, səhifəni yeniləməyə cəhd edin",
  unselect: "Seçimi ləğv edin",
  untilStartLeft: "Başlanmasına qədər vaxt qalıb",
  update: "Yeniləmək",
  upload: "Yüklə",
  uzbek: "Özbək",
  verification: "Verifikasiya",
  verificationDeclined: "Yoxlama rədd edildi. Zəhmət olmasa Müştəri xidməti ilə əlaqə saxlayın.",
  verificationDeclinedInfo: "Sənədlər yoxlamadan keçmədi. Xahiş edirik, sənədləri yenidən əlavə edin və ya Müştəri xidməti ilə əlaqə saxlayın.",
  verificationInProgress: "Yoxlama aparılır. Zəhmət olmasa gözləyin.",
  verificationsSMSDesc: "Ödənişlərin yoxlanıb təsdiqlənməsi üçün qeydiyyat zamanı göstərdiyiniz telefon nömrəsini təsdiqləyin",
  verifyYourAccount: "Hesabınızı təsdiqlədin",
  virtuals: "V-Sport",
  wager: "Bahis",
  wagerGame: {
    accessAfterRolePlay: "Oyuna daxil olmaq bonusun udulub qaytarılması başa çatdıqdan sonra mümkün olacaq",
    gamesWagering: "Udub qaytarmanın mümkün olduğu oyunlar",
    nowPlayed: "İndi udulub qaytarılmışdır",
    remainForPlay: "Udub qaytarmaq qalıb"
  },
  wallet: "Pul kisəsi",
  walletCopied: "Pul kisəsi kopyalandı",
  walletId: "Pulqabının ünvanı",
  walletNotLinked: "Pul kisəsi əlaqələndirilməyib",
  way: "Çıxarma üsulu",
  ways: "Çıxarma üsulları",
  wbCashboxActiveText: "Bonus hesabınıza depozitə görə 100% almaq üçün hesabınızı {minSum} və daha yuxarı məbləğdə artırın. Əsas hesab bonusu mərc etdikdən sonra mövcud olacaq.",
  wbCashboxNotActiveText: "Bonus hesabınıza depozitə görə 100% almaq üçün şəxsi hesabınızda bonusu aktivləşdirin.",
  wbWaitOnProfile: "Xoşgəldin bonusu sizi şəxsi kabinetinizin “Bonuslar” bölməsində gözləyir",
  welcomeBonus: "Welcome bonus",
  welcomeBonusCasino: "Welcome bonus kazino",
  welcomeBonusDescription: "Bir saat ərzində ödəniş etməyə tələsin və artırılmış bonus qazanın <span class='text-accent'>125%</span> depozitə görə və 250-dək frispin!",
  welcomeBonusSport: "Welcome bonus idman",
  welcomeBonusTitle: "Welcome bonusa +25%",
  win: "Qələbə",
  winnerPoints: "Qaliblərin xalları",
  winners: "Qaliblər",
  withAnIncrease: "Artan zaman",
  withDrawOrdered: "Çıxarış rəsmiləşdirildi",
  withDrawOrderedDesc: "Vəsaitlər qısa müddətdə qeyd etdiyiniz hesabınıza köçürüləcək.",
  withInstantCashback: "Ani keşbek ilə",
  withdraw: "Çıxarmaq",
  withdraw2: "-ya çıxarmaq",
  withdrawBK: "BK-ə çıxarış",
  withdrawFunds: "Vəsaitlərin çıxarılması",
  withdrawMethod: "Çıxarma üsulu",
  withdrawMethods: "Çıxarma üsulları",
  withdrawNoun: "Çıxarma",
  withdrawPaymentInfo: "Visa/Mastercard vasitəsilə vəsait çıxarışı yalnız loginizlə əlaqələndirilmiş kartlar üçün mümkündür. Əlaqələndirmək üçün siz Visa/Mastercard metodundan istifadə edərək logininizi artırmalısınız.",
  withdrawPerDayCountExceeded: "Hər gün 1 vəsait çıxarışı edə bilərsiniz",
  withdrawTelegramBot: "Vəsait çıxarışı üçün Telegram botunu işə salıb ora daxil olmaq lazımdır",
  withdrawWithApprove: "Kod təsdiqi ilə vəsaitin çıxarılması",
  withdrawWithCode: "Kod təsdiqi ilə vəsaitin çıxarılması",
  withdrawal: "Vəsaitlərin çıxarılmasına qoyulan məhdudiyyətlər",
  withdrawalCompletedSuccessfully: "Vəsait çıxarışı üçün sifariş yaradıldı",
  withdrawalOfFunds: "Kod təsdiqi ilə vəsaitin çıxarılması",
  work: "Texniki işlər aparılır",
  writeToSupport: "Müştəri xidmətinə yazın",
  yes: "Bəli",
  yesConfirm: "Bəli, əminəm",
  yesOfCourseIWant: "Bəli, əlbəttə istəyirəm",
  yesRefundWithdrawal: "Bəli, vəsait çıxarışı ləğv edilsin",
  yesSure: "Bəli, hesabı artırdım",
  you: "Sən",
  youAreAuthorized: "Siz avtorizasiya olunmusunuz",
  youAreParticipateInTheTournament: "Siz turnirdə iştirak edirsiniz!",
  youDontHaveTransactions: "Hələ heç bir əməliyyatınız olmayıb",
  youHaveNewMessage: "Yeni mesajınız var",
  youHaveNotNewMessages: "Sizin yeni mesajlarınız yoxdur",
  youHaveSmsVerification: "Sizdə ödənişlərin yoxlanıb təsdiqlənməsi qoşulub, köçürmənin yerinə yetirilməsi üçün SMS vasitəsilə yoxlamadan keçin",
  youTakePart: "Siz iştirak edirsiniz",
  yourBalance: "Sizin balansınız",
  yourCasinoBonus: "Kazinoda bonusunuz",
  yourCurrentEmail: "Sizin indiki elektron poçtunuz",
  yourCurrentPhone: "Sizin indiki nömrəniz",
  yourEmail: "Sizin elektron poçtunuz",
  yourPersonalUniqueWalletIsDisplayedHere: "Здесь отображен ваш личный уникальный кошелек для той монеты, которую вы выбрали ранее. Для копирования адреса кошелька можно использовать специальную кнопку или QR код."
} 
